(function () {
  'use strict';

  function _loadConfig() {
    const el = document.getElementById('gncc-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch { return {}; }
  }
  const CFG = _loadConfig();

  const UPRIGHT_16MM_LENGTHS    = [600, 900, 1200, 1500];
  const UPRIGHT_16MM_CONNECTORS = [600, 900];
  const CROSS_13MM_LENGTHS      = [600, 900, 987, 1080, 1200, 1500];
  const CROSS_13MM_CONNECTORS   = [600, 900];

  const POLE_PACK_SIZES          = [1, 4, 6, 8, 10];

  const BUILD_A_BALL_PACKS       = [1, 4, 12, 24];
  const THREE_VARIANT_2WAY_PACKS = [1, 4, 8];
  const THREE_VARIANT_3WAY_PACKS = [1, 4, 6];
  const THREE_VARIANT_4WAY_PACKS = [1, 4, 6];

  const NETTING_CLIP_PACKS = [20, 50];
  const U_PEG_PACKS        = [25, 50, 100, 1000];
  const GALV_PEG_PACKS     = [20, 30, 50, 100, 200, 500, 1000];

  const CLIP_SPACING_MM = 1000;
  const PEG_SPACING_MM  = 500;
  const NETTING_WIDTH_TOLERANCE_MM = 100;
  const MIN_FIXED_ONLY_LENGTH_M = 20;
  const INTERNAL_SUPPORT_MAX_BAY_MM = 2000;

  const POLE_TO_CAGE_HEIGHT_MM      = { 600: 500, 900: 700, 1200: 900, 1500: 1200 };
  const WALKIN_POLE_TO_HEIGHT_MM    = { 1500: 1200, 1854: 1554, 2000: 1700, 2200: 1900 };
  const LOW_19MM_POLE_TO_HEIGHT_MM  = { 1500: 1200, 1854: 1554 };
  const WALKIN_HORIZ_LENGTHS        = [1200, 1500, 1854, 2000, 2200];
  const LOW_19MM_HORIZ_LENGTHS      = [1200, 1500, 1854, 2000];

  const NETTING_CATALOGUE = {
    anti_bird_black:     { display_name: 'Anti-Bird Netting (Black)',        widths_mm: [2000,4000,6000,8000,12000], lengths_m: [5,10,20,100], per_metre: true, fixed_roll_lengths: {12000:[5,10,20,50]} },
    soft_butterfly:      { display_name: 'Soft Butterfly Netting (Black)',   widths_mm: [2000,3000,4000,5000,6000,8000], lengths_m: [5,10,20,50,100], per_metre: true, per_metre_widths_mm: [2000,3000,4000,6000,8000], fixed_roll_lengths: {3000:[4,5,6,10,20,100],5000:[5]} },
    soft_butterfly_green:{ display_name: 'Soft Butterfly Netting (Green)',   widths_mm: [2000,3000,4000,5000,6000,8000], lengths_m: [5,10,20,50,100], per_metre: true, per_metre_widths_mm: [2000,3000,4000,6000,8000], fixed_roll_lengths: {3000:[4,5,6,10,20,100],5000:[5]} },
    veggiemesh:          { display_name: 'Veggiemesh Insect Netting',        widths_mm: [1800,2100,2600,3600,4200,5600], lengths_m: [3,5,10,20,50,100], per_metre: true, fixed_roll_lengths: {1800:[3,5,10,20,50,100],2100:[3,5,10,20,50,100],2600:[3,5,10,20,50,100],3600:[3,5,10,20,50,100],4200:[3,5,10,20,50,100],5600:[3,5,10,50]} },
    ultra_fine_veggiemesh:{ display_name: 'Ultra-Fine Veggiemesh',           widths_mm: [1800,2100,2600,3600,4100,4200], lengths_m: [3,5,10,20,100], per_metre: true, fixed_roll_lengths: {1800:[3,5,10,20,100],2100:[3,5,10,20,100],2600:[3,5,10,20,100],3600:[3,5,10,20,100],4100:[3,5,10,20,100],4200:[100]}, per_metre_widths_mm: [1800,2100,2600,3600,4100] },
    green_bird:          { display_name: 'Green Bird Netting',               widths_mm: [2000,4000,6000,8000], lengths_m: [5,10,20,100], per_metre: true, fixed_roll_lengths: {4000:[3,5,10,20,100]} },
    poultry_fruit:       { display_name: 'Poultry and Fruit Cage Netting',   widths_mm: [1000,2000], lengths_m: [5,10,15,200], per_metre: true },
  };

  const LOW_FV_NETTING_TYPES   = ['anti_bird_black','soft_butterfly','soft_butterfly_green','veggiemesh','ultra_fine_veggiemesh','green_bird'];
  const WALKIN_NETTING_TYPES   = ['anti_bird_black','soft_butterfly','soft_butterfly_green','green_bird'];
  const LOW_19MM_NETTING_TYPES = ['soft_butterfly','soft_butterfly_green','anti_bird_black','green_bird','veggiemesh'];
  const PREMIUM_NETTING_TYPES  = ['soft_butterfly','soft_butterfly_green','anti_bird_black','green_bird'];

  const PREMIUM_POLE_MM   = 2200;
  const PREMIUM_HEIGHT_MM = 1900;
  const PREMIUM_HORIZ_LENGTHS = [750, 1500, 1854, 2000, 2200];

  const SINGLE_ROLL_NETTING_TYPES = ['soft_butterfly', 'soft_butterfly_green', 'green_bird'];

  function isSingleRollNetting(netting, nettingSecondary) {
    if (!netting || !nettingSecondary) return false;
    if (!SINGLE_ROLL_NETTING_TYPES.includes(netting.netting_type)) return false;
    return netting.chosen_width_mm === 2000 && nettingSecondary.chosen_width_mm === 2000;
  }

  function buildPoleChain(targetMm, baseLengths, connectorLengths) {
    const sortedExts = [...new Set(connectorLengths)].sort((a,b)=>b-a);
    const minExt = sortedExts.length ? sortedExts[sortedExts.length-1] : Infinity;
    let best = null;
    function tryBetter(base, exts, actualMm) {
      const overshoot = actualMm - targetMm;
      const pieces = [base, ...exts].sort((a,b)=>b-a);
      const pc = pieces.length;
      if (!best || overshoot < best.overshoot || (overshoot === best.overshoot && pc < best.pc))
        best = {base, exts, actualMm, overshoot, pieces, pc};
    }
    for (const base of baseLengths) {
      if (base >= targetMm) { tryBetter(base, [], base); continue; }
      const gap = targetMm - base;
      const maxIter = Math.ceil(gap / minExt) + 1;
      const dp = new Map([[0, {count:0, combo:[]}]]);
      const maxSearch = gap + (sortedExts[0] || 0);
      for (let iter = 0; iter < maxIter; iter++) {
        let changed = false;
        for (const [q, {count, combo}] of [...dp.entries()]) {
          for (const ext of sortedExts) {
            const nq = q + ext;
            if (nq > maxSearch) continue;
            const nc = count + 1;
            if (!dp.has(nq) || nc < dp.get(nq).count) {
              dp.set(nq, {count: nc, combo: [...combo, ext].sort((a,b)=>b-a)});
              changed = true;
            }
          }
        }
        if (!changed) break;
      }
      for (const [extSum, {combo}] of dp.entries()) {
        const actualMm = base + extSum;
        if (actualMm >= targetMm) tryBetter(base, combo, actualMm);
      }
    }
    if (!best) throw new Error(`Cannot build ${targetMm}mm span`);
    const connSet = new Set(connectorLengths);
    const connectors = best.exts.filter(e => connSet.has(e));
    const extraBases = best.exts.filter(e => !connSet.has(e));
    const joints = []; let cur = 0;
    for (let i = 0; i < best.pieces.length - 1; i++) { cur += best.pieces[i]; joints.push(cur); }
    return {targetMm, actualMm: best.actualMm, bases: [best.base, ...extraBases], connectors, pieces: best.pieces, joints};
  }

  function snapSpanToChains(targetMm, baseLengths, connectorLengths, maxBayMm) {
    const achievable = new Set();
    for (const base of baseLengths) {
      if (base > maxBayMm) continue;
      achievable.add(base);
      for (let n = 1; n <= 15; n++) {
        function* combos(arr, k) {
          if (k === 0) { yield []; return; }
          for (let i = 0; i < arr.length; i++)
            for (const rest of combos(arr.slice(i), k-1))
              yield [arr[i], ...rest];
        }
        let any = false;
        for (const ext of combos(connectorLengths, n)) {
          const total = base + ext.reduce((a,b)=>a+b, 0);
          if (total <= maxBayMm) { achievable.add(total); any = true; }
        }
        if (!any) break;
      }
    }
    const pureBaseSet=new Set(baseLengths);
    const achSorted=[...achievable].sort((a,b)=>{const aP=pureBaseSet.has(a),bP=pureBaseSet.has(b);if(aP!==bP)return aP?-1:1;return b-a;});
    const maxN = Math.ceil(targetMm / maxBayMm);
    const dp = new Map([[0, {n:0, segs:[]}]]);
    for (let iter = 0; iter < maxN; iter++) {
      for (const [curr, {n, segs}] of [...dp.entries()]) {
        if (n >= maxN) continue;
        for (const seg of achSorted) {
          const next = curr + seg;
          if (next > targetMm) continue;
          if (!dp.has(next) || dp.get(next).n > n+1)
            dp.set(next, {n: n+1, segs: [...segs, seg]});
        }
      }
    }
    const bestTotal = Math.max(...dp.keys());
    const {segs} = dp.get(bestTotal);
    segs.sort((a,b)=>b-a);
    return segs.map(seg => buildPoleChain(seg, baseLengths, connectorLengths));
  }

  function optimisePacks(required,packSizes){
    if(required<=0)return{};
    const maxSearch=required+Math.max(...packSizes);
    const dp=new Map([[0,{packs:0,combo:{}}]]);
    for(let q=0;q<=maxSearch;q++){
      if(!dp.has(q))continue;
      const{packs,combo}=dp.get(q);
      for(const size of packSizes){const nq=q+size;if(nq>maxSearch)continue;const newPacks=packs+1;if(!dp.has(nq)||dp.get(nq).packs>newPacks){const newCombo=Object.assign({},combo);newCombo[size]=(newCombo[size]||0)+1;dp.set(nq,{packs:newPacks,combo:newCombo});}}
    }
    const valid=[...dp.keys()].filter(q=>q>=required);
    if(!valid.length){const s=Math.max(...packSizes);return{[s]:Math.ceil(required/s)};}
    const bestQ=valid.reduce((best,q)=>{const bScore=(best-required)*1000+dp.get(best).packs,qScore=(q-required)*1000+dp.get(q).packs;return qScore<bScore?q:best;});
    return dp.get(bestQ).combo;
  }

  function packSelection(skuDesc,required,packSizes){
    const packs=optimisePacks(required,packSizes);
    const total=Object.entries(packs).reduce((s,[sz,ct])=>s+Number(sz)*ct,0);
    return{sku:skuDesc,required_qty:required,packs,total_supplied:total,leftover:total-required};
  }

  function snapSpanToPoles(spanMm,lengths,label='span'){
    const desc=[...lengths].sort((a,b)=>b-a);
    let frontier=new Map([[0,[]]]);
    for(let n=1;n<=8;n++){
      const next=new Map();
      for(const[sum,combo]of frontier){
        for(const len of desc){
          const nsum=sum+len;
          if(nsum>spanMm||next.has(nsum))continue;
          next.set(nsum,[...combo,len]);
        }
      }
      if(next.has(spanMm))return next.get(spanMm).sort((a,b)=>b-a);
      frontier=next;
    }
    const maxSpanMm=8*Math.max(...lengths);
    if(spanMm>maxSpanMm){
      throw new Error(`Requested ${label} of ${spanMm}mm exceeds the maximum ${maxSpanMm}mm achievable in one run with stocked pole lengths (up to 8 poles). Reduce the ${label}, or choose the Low Fruit & Veg Cage (13mm/16mm), which supports longer runs using internal supports.`);
    }
    throw new Error(`Cannot build an exact ${label} of ${spanMm}mm from the available pole lengths. Try a slightly different ${label}.`);
  }

  function splitAtPositions(totalMm,positions){
    const pts=[0,...positions,totalMm],segs=[];
    for(let i=0;i<pts.length-1;i++)segs.push(pts[i+1]-pts[i]);
    return segs;
  }

  function nettingFailureMessage(spec,failures){
    const lengthFail=failures.filter(f=>f.reason==='length').sort((a,b)=>a.reqLm-b.reqLm)[0];
    if(lengthFail){
      return `${spec.display_name} max roll length ${Math.max(...spec.lengths_m)}m cannot cover required ${lengthFail.reqLm.toFixed(2)}m (L + 2H). Pick a different netting type or reduce cage length/height.`;
    }
    const widthFail=failures.filter(f=>f.reason==='width').sort((a,b)=>a.reqW-b.reqW)[0];
    const maxW=Math.max(...spec.widths_mm);
    return `${spec.display_name} max roll width ${maxW}mm is not wide enough to cover ${widthFail.reqW}mm (W + 2H) with pegging allowance. Pick a wider netting type or reduce cage height/width.`;
  }

  function chooseNetting(nettingType,heightMm,widthMm,lengthMm){
    const spec=NETTING_CATALOGUE[nettingType];
    const failures=[];
    function tryOrientation(coverW,coverL){
      const reqW=coverW+2*heightMm,reqLm=(coverL+2*heightMm)/1000;
      const pmWidths=spec.per_metre_widths_mm;
      const isPmWidth=w=>spec.per_metre&&(!pmWidths||pmWidths.includes(w));
      const fixedOnlyExcluded=spec.widths_mm.filter(w=>{
        if(isPmWidth(w))return false;
        const fixed=(spec.fixed_roll_lengths||{})[w];
        return fixed&&Math.min(...fixed)>=MIN_FIXED_ONLY_LENGTH_M&&reqLm<MIN_FIXED_ONLY_LENGTH_M;
      });
      const candidateWidths=spec.widths_mm.filter(w=>!fixedOnlyExcluded.includes(w));
      let ws=candidateWidths.filter(w=>w+NETTING_WIDTH_TOLERANCE_MM>=reqW);
      if(!ws.length&&fixedOnlyExcluded.length&&candidateWidths.length){
        const wouldFitIfIncluded=spec.widths_mm.some(w=>w+NETTING_WIDTH_TOLERANCE_MM>=reqW);
        if(wouldFitIfIncluded)ws=[Math.max(...candidateWidths)];
      }
      if(!ws.length){failures.push({reason:'width',reqW});return null;}
      const chosenW=Math.min(...ws);
      const isPerMetre=isPmWidth(chosenW);
      const fixed=(spec.fixed_roll_lengths||{})[chosenW];
      let chosenL;
      if(fixed){
        const fixedValid=fixed.filter(l=>l>=reqLm);
        if(isPerMetre){const pmL=Math.ceil(reqLm);const bestFixed=fixedValid.length?Math.min(...fixedValid):Infinity;chosenL=pmL<=bestFixed?pmL:bestFixed;}
        else if(fixedValid.length){chosenL=Math.min(...fixedValid);}
        else{failures.push({reason:'length',reqLm});return null;}
      } else {
        const candidates=[...spec.lengths_m];if(isPerMetre)candidates.push(Math.ceil(reqLm));const valid=candidates.filter(l=>l>=reqLm);if(!valid.length){failures.push({reason:'length',reqLm});return null;}chosenL=Math.min(...valid);
      }
      return{netting_type:nettingType,display_name:spec.display_name,required_width_mm:reqW,chosen_width_mm:chosenW,chosen_length_m:chosenL};
    }
    const r1=tryOrientation(widthMm,lengthMm);
    const r2=tryOrientation(lengthMm,widthMm);
    const result=(!r1&&!r2)?null:(!r1)?r2:(!r2)?r1:
      (r1.chosen_width_mm<r2.chosen_width_mm)?r1:
      (r2.chosen_width_mm<r1.chosen_width_mm)?r2:
      (r1.chosen_width_mm*r1.chosen_length_m<=r2.chosen_width_mm*r2.chosen_length_m)?r1:r2;
    if(!result)throw new Error(nettingFailureMessage(spec,failures));
    return result;
  }

  function chooseRoofNetting(nettingType,widthMm,lengthMm,overhangMm=500){
    const spec=NETTING_CATALOGUE[nettingType];
    const failures=[];
    function tryOrientation(coverW,coverL){
      const reqW=coverW+overhangMm,reqLm=(coverL+overhangMm)/1000;
      const pmWidths=spec.per_metre_widths_mm;
      const isPmWidth=w=>spec.per_metre&&(!pmWidths||pmWidths.includes(w));
      const fixedOnlyExcluded=spec.widths_mm.filter(w=>{
        if(isPmWidth(w))return false;
        const fixed=(spec.fixed_roll_lengths||{})[w];
        return fixed&&Math.min(...fixed)>=MIN_FIXED_ONLY_LENGTH_M&&reqLm<MIN_FIXED_ONLY_LENGTH_M;
      });
      const candidateWidths=spec.widths_mm.filter(w=>!fixedOnlyExcluded.includes(w));
      const ws=candidateWidths.filter(w=>w+NETTING_WIDTH_TOLERANCE_MM>=reqW);
      if(!ws.length){failures.push({reason:'width',reqW});return null;}
      const chosenW=Math.min(...ws);
      const isPerMetre=isPmWidth(chosenW);
      const fixed=(spec.fixed_roll_lengths||{})[chosenW];
      let candidates;
      if(fixed){candidates=[...fixed];if(isPerMetre)candidates.push(Math.ceil(reqLm));}
      else if(isPerMetre){candidates=[Math.ceil(reqLm)];}
      else{candidates=[...spec.lengths_m];}
      let valid=candidates.filter(l=>l>=reqLm);
      if(!valid.length){const fallback=[...spec.lengths_m];if(isPerMetre)fallback.push(Math.ceil(reqLm));valid=fallback.filter(l=>l>=reqLm);}
      if(!valid.length){failures.push({reason:'length',reqLm});return null;}
      return{netting_type:nettingType,display_name:spec.display_name+' (roof)',required_width_mm:reqW,chosen_width_mm:chosenW,chosen_length_m:Math.min(...valid)};
    }
    const r1=tryOrientation(widthMm,lengthMm);
    const r2=tryOrientation(lengthMm,widthMm);
    const result=(!r1&&!r2)?null:(!r1)?r2:(!r2)?r1:
      (r1.chosen_width_mm*r1.chosen_length_m<r2.chosen_width_mm*r2.chosen_length_m)?r1:
      (r2.chosen_width_mm*r2.chosen_length_m<r1.chosen_width_mm*r1.chosen_length_m)?r2:
      (r1.chosen_width_mm<=r2.chosen_width_mm)?r1:r2;
    if(!result){
      const lengthFail=failures.filter(f=>f.reason==='length').sort((a,b)=>a.reqLm-b.reqLm)[0];
      if(lengthFail){
        throw new Error(`${spec.display_name} (roof) max roll length ${Math.max(...spec.lengths_m)}m cannot cover required ${lengthFail.reqLm.toFixed(2)}m (roof span + ${overhangMm}mm overhang). Pick a different netting type or reduce cage dimensions.`);
      }
      const widthFail=failures.filter(f=>f.reason==='width').sort((a,b)=>a.reqW-b.reqW)[0];
      const maxW=Math.max(...spec.widths_mm);
      throw new Error(`${spec.display_name} (roof) max roll width ${maxW}mm is not wide enough to cover ${widthFail.reqW}mm (roof span + ${overhangMm}mm overhang). Pick a wider netting type or reduce cage dimensions.`);
    }
    return result;
  }

  function chooseSideNetting(nettingType,widthMm,lengthMm,sideWrapWidthMm=2000){
    const spec=NETTING_CATALOGUE[nettingType];
    const perimeterMm=2*(widthMm+lengthMm),reqLm=Math.ceil(perimeterMm/1000)+1;
    const ws=spec.widths_mm.filter(w=>w>=sideWrapWidthMm);
    if(!ws.length){
      const maxW=Math.max(...spec.widths_mm);
      throw new Error(`${spec.display_name} (side wrap) max roll width ${maxW}mm is not wide enough to cover the required ${sideWrapWidthMm}mm side-wrap height. Pick a wider netting type.`);
    }
    const chosenW=Math.min(...ws);
    const isPerMetre=spec.per_metre;
    let candidates=[...spec.lengths_m].filter(l=>l>=reqLm);
    if(isPerMetre)candidates.push(reqLm);
    if(!candidates.length)throw new Error(`${spec.display_name} (side wrap) max roll length ${Math.max(...spec.lengths_m)}m cannot cover required ${reqLm}m (2×(W+L) perimeter + 1m overlap). Pick a different netting type or reduce cage width/length.`);
    return{netting_type:nettingType,display_name:spec.display_name+' (side wrap)',required_width_mm:sideWrapWidthMm,chosen_width_mm:chosenW,chosen_length_m:Math.min(...candidates)};
  }

  function lowFvHeightToPole(heightMm){
    const entries=Object.entries(POLE_TO_CAGE_HEIGHT_MM).map(([p,h])=>[Number(p),h]).sort((a,b)=>a[1]-b[1]);
    for(const[pole,h]of entries)if(h>=heightMm)return{pole,achieved:h};
    throw new Error(`Height ${heightMm}mm exceeds catalogue maximum`);
  }
  function walkinHeightToPole(heightMm){
    const entries=Object.entries(WALKIN_POLE_TO_HEIGHT_MM).map(([p,h])=>[Number(p),h]).sort((a,b)=>a[1]-b[1]);
    for(const[pole,h]of entries)if(h>=heightMm)return{pole,achieved:h};
    throw new Error(`Height ${heightMm}mm exceeds walk-in maximum`);
  }
  function low19mmHeightToPole(heightMm){
    const entries=Object.entries(LOW_19MM_POLE_TO_HEIGHT_MM).map(([p,h])=>[Number(p),h]).sort((a,b)=>a[1]-b[1]);
    for(const[pole,h]of entries)if(h>=heightMm)return{pole,achieved:h};
    throw new Error(`Height ${heightMm}mm exceeds 19mm low cage maximum`);
  }

  const _achievableSetCache = new WeakMap();
  function _achievableSums(horizLengths){
    let achievable = _achievableSetCache.get(horizLengths);
    if (achievable) return achievable;
    achievable = new Set();
    let frontier = new Set([0]);
    for (let n = 1; n <= 8; n++) {
      const next = new Set();
      for (const sum of frontier) for (const len of horizLengths) next.add(sum + len);
      for (const sum of next) achievable.add(sum);
      frontier = next;
    }
    _achievableSetCache.set(horizLengths, achievable);
    return achievable;
  }

  function snapToAchievable(dimMm, horizLengths){
    horizLengths = horizLengths || WALKIN_HORIZ_LENGTHS;
    const achievable = _achievableSums(horizLengths);
    if (achievable.has(dimMm)) return dimMm;
    for (let c = dimMm + 1; c <= dimMm + 2000; c++) { if (achievable.has(c)) return c; }
    return Math.ceil(dimMm/1000)*1000;
  }

  function fullBarJoins(poles,rolePrefix,splitPositions,totalMm){
    const subRuns=poles.filter(p=>p.role.startsWith(rolePrefix)).sort((a,b)=>a.role.localeCompare(b.role));
    if(!subRuns.length)return{allJoins:[],repPieces:[],repConnectors:[]};
    const boundaries=[0,...splitPositions,totalMm],allJoins=[],repPieces=subRuns[0].pieces,repConnectors=subRuns[0].connectors||[];
    for(let idx=0;idx<subRuns.length;idx++){const segStart=boundaries[idx]||0;let acc=0;for(const p of subRuns[idx].pieces.slice(0,-1)){acc+=p;allJoins.push(segStart+acc);}}
    return{allJoins:allJoins.sort((a,b)=>a-b),repPieces,repConnectors};
  }

  function calculateLowFruitVeg({heightMm,widthMm,lengthMm,nettingType='none',joinerSystem='three_variant',pegType='u_peg'}){
    const{pole:uprightPole,achieved:achievedH}=lowFvHeightToPole(heightMm);
    const lenChains=snapSpanToChains(lengthMm,CROSS_13MM_LENGTHS,CROSS_13MM_CONNECTORS,INTERNAL_SUPPORT_MAX_BAY_MM);
    const widChains=snapSpanToChains(widthMm,CROSS_13MM_LENGTHS,CROSS_13MM_CONNECTORS,INTERNAL_SUPPORT_MAX_BAY_MM);
    const M=lenChains.length-1, K=widChains.length-1;
    let actualLengthMm=lenChains.reduce((s,c)=>s+c.actualMm,0);
    let actualWidthMm=widChains.reduce((s,c)=>s+c.actualMm,0);
    let bracePos=[],rowPos=[];
    {let acc=0;lenChains.slice(0,-1).forEach(ch=>{acc+=ch.actualMm;bracePos.push(acc);});}
    {let acc=0;widChains.slice(0,-1).forEach(ch=>{acc+=ch.actualMm;rowPos.push(acc);});}
    const poles=[];
    const su=(s,c)=>s.length===1?'':`_seg${c+1}`;
    const cornerQty=4,internalQty=2*K+2*M+K*M;
    poles.push({role:'corner_upright',pieces:[uprightPole],diameter:16,qty:cornerQty,bases:[uprightPole],connectors:[]});
    if(internalQty>0)poles.push({role:'internal_upright',pieces:[uprightPole],diameter:16,qty:internalQty,bases:[uprightPole],connectors:[]});
    lenChains.forEach((ch,i)=>poles.push({role:`top_length${su(lenChains,i)}`,pieces:ch.pieces,diameter:13,qty:2,bases:ch.bases,connectors:ch.connectors}));
    widChains.forEach((ch,i)=>poles.push({role:`top_width${su(widChains,i)}`,pieces:ch.pieces,diameter:13,qty:2,bases:ch.bases,connectors:ch.connectors}));
    if(K>0)lenChains.forEach((ch,i)=>poles.push({role:`internal_row${su(lenChains,i)}`,pieces:ch.pieces,diameter:13,qty:K,bases:ch.bases,connectors:ch.connectors}));
    if(M>0)widChains.forEach((ch,i)=>poles.push({role:`cross_brace${su(widChains,i)}`,pieces:ch.pieces,diameter:13,qty:M,bases:ch.bases,connectors:ch.connectors}));
    const skuQtys={};
    for(const pr of poles){for(const p of pr.bases){const k=`${pr.diameter}|${p}|base`;skuQtys[k]=(skuQtys[k]||0)+pr.qty;}for(const p of pr.connectors){const k=`${pr.diameter}|${p}|connector`;skuQtys[k]=(skuQtys[k]||0)+pr.qty;}}
    const polePacks=Object.entries(skuQtys).sort().map(([k,qty])=>{const[dia,len,role]=k.split('|');const label=role==='connector'?'extension':Number(dia)===13?'cross bar':'upright';return packSelection(`${dia}mm ${label} — ${len}mm`,qty,POLE_PACK_SIZES);});
    const cornerCount=4,teeCount=2*K+2*M,crossCount=K*M;
    const joiners=[];
    if(joinerSystem==='build_a_ball'){joiners.push(packSelection('Build-A-Ball joiner (1×16mm + 5×13mm)',cornerCount+teeCount+crossCount,BUILD_A_BALL_PACKS));}
    else{joiners.push(packSelection('Joiner — 2-way 90° corner (1×16mm + 2×13mm)',cornerCount,THREE_VARIANT_2WAY_PACKS));if(teeCount>0)joiners.push(packSelection('Joiner — 3-way tee (1×16mm + 3×13mm)',teeCount,THREE_VARIANT_3WAY_PACKS));if(crossCount>0)joiners.push(packSelection('Joiner — 4-way cross (1×16mm + 4×13mm)',crossCount,THREE_VARIANT_4WAY_PACKS));}
    const clips=[];let pegsObj=null;
    if(nettingType!=='none'){const perimMm=2*(widthMm+lengthMm);const clipsEach=Math.max(1,Math.ceil(perimMm/CLIP_SPACING_MM));clips.push(packSelection('Netting clips — 16mm',clipsEach,NETTING_CLIP_PACKS));clips.push(packSelection('Netting clips — 13mm',clipsEach,NETTING_CLIP_PACKS));if(pegType!=='none'){const pegsReq=Math.max(4,Math.ceil(perimMm/PEG_SPACING_MM));pegsObj=packSelection(pegType==='u_peg'?'U-pegs':'Galvanised Steel Garden Pegs',pegsReq,pegType==='u_peg'?U_PEG_PACKS:GALV_PEG_PACKS);}}
    let netting=null;
    if(nettingType!=='none')netting=chooseNetting(nettingType,achievedH,widthMm,lengthMm);
    const{allJoins:lenJoins,repPieces:lenPieces,repConnectors:lenConnectors}=fullBarJoins(poles,'top_length',bracePos,actualLengthMm);
    const{allJoins:widJoins,repPieces:widPieces,repConnectors:widConnectors}=fullBarJoins(poles,'top_width',rowPos,actualWidthMm);
    const notices=[];
    if(achievedH!==heightMm)notices.push(`Erected height adjusted to ${achievedH}mm (nearest achievable with a ${uprightPole}mm pole).`);
    if(actualWidthMm!==widthMm)notices.push(`Width adjusted from ${widthMm/1000}m to ${actualWidthMm/1000}m — nearest size using stocked pole lengths.`);
    if(actualLengthMm!==lengthMm)notices.push(`Length adjusted from ${lengthMm/1000}m to ${actualLengthMm/1000}m — nearest size using stocked pole lengths.`);
    return{cage_type:'low_fruit_veg',dimensions_mm:{height:achievedH,width:actualWidthMm,length:actualLengthMm,requested_height:heightMm,requested_width:widthMm,requested_length:lengthMm,upright_pole_length:uprightPole},joiner_system:joinerSystem,poles,pole_packs:polePacks,joiners,clips,pegs:pegsObj,netting,netting_secondary:null,notices,summary:{achievable_height_mm:achievedH,upright_pole_length_mm:uprightPole,corner_uprights:cornerCount,internal_uprights:internalQty,total_uprights:cornerCount+internalQty,corner_joiners:cornerCount,tee_joiners:teeCount,cross_joiners:crossCount,total_joiners_required:cornerCount+teeCount+crossCount,cross_braces:M,cross_brace_positions_mm:bracePos,internal_support_rows:K,internal_row_positions_mm:rowPos,length_bar_join_positions_mm:lenJoins,width_bar_join_positions_mm:widJoins,length_bar_pieces_mm:lenPieces,width_bar_pieces_mm:widPieces,length_bar_connectors_mm:lenConnectors,width_bar_connectors_mm:widConnectors,door:null}};
  }

  function calculateWalkIn({heightMm,widthMm,lengthMm,nettingType='none',pegType='u_peg',doorCount=0,cornerBraces=true}){
    const reqW=widthMm,reqL=lengthMm;
    widthMm=snapToAchievable(widthMm);lengthMm=snapToAchievable(lengthMm);
    const{pole:uprightPole,achieved:achievedH}=walkinHeightToPole(heightMm);
    const notices=[];
    if(widthMm!==reqW||lengthMm!==reqL)notices.push(`Footprint adjusted to ${(widthMm/1000).toFixed(3).replace(/\.?0+$/,'')}m × ${(lengthMm/1000).toFixed(3).replace(/\.?0+$/,'')}m (you requested ${reqW/1000}m × ${reqL/1000}m). Dimensions are snapped to the nearest size achievable with stocked pole lengths.`);
    const lenBayPoles=snapSpanToPoles(lengthMm,WALKIN_HORIZ_LENGTHS,'length');
    const widBayPoles=snapSpanToPoles(widthMm,WALKIN_HORIZ_LENGTHS,'width');
    function joinPositions(poles){const pos=[];let acc=0;for(const p of poles.slice(0,-1)){acc+=p;pos.push(acc);}return pos;}
    const bracePos=joinPositions(lenBayPoles),rowPos=joinPositions(widBayPoles);
    const K=rowPos.length,M=bracePos.length;
    const doorEnabled=doorCount>0;
    const dHalf=375;
    const doorPos=doorEnabled?Math.max(0,Math.min(1,(dHalf<=lengthMm?dHalf:-dHalf)/lengthMm)):0;
    const totalUprights=4+2*K+2*M+K*M;
    const poleQtys={};poleQtys[uprightPole]=(poleQtys[uprightPole]||0)+totalUprights;
    const addPoles=(list,qty)=>list.forEach(p=>{poleQtys[p]=(poleQtys[p]||0)+qty;});
    addPoles(lenBayPoles,2+K);addPoles(widBayPoles,2+M);
    const polePacks=Object.entries(poleQtys).sort(([a],[b])=>Number(b)-Number(a)).map(([len,qty])=>packSelection(`19mm aluminium tube — ${len}mm`,qty,POLE_PACK_SIZES));
    const cornerCount=4,teeCount=2*K+2*M,crossCount=K*M;
    const joiners=[];
    joiners.push(packSelection('19mm Joiner Corner For Fruit and Vegetable Cages',cornerCount,[1]));
    if(teeCount>0)joiners.push(packSelection('19mm Joiner Tee (For Fruit and Vegetable Cage Connector)',teeCount,[1]));
    if(crossCount>0)joiners.push(packSelection('19mm Joiner Cross For Fruit and Vegetable Cages',crossCount,[1]));
    if(cornerBraces)joiners.push(packSelection('Corner Brace kit for Walk-In Cages',1,[1]));
    if(doorEnabled)joiners.push(packSelection('Door Kit',doorCount,[1]));
    joiners.push(packSelection('Aluminium Anchors for 19mm Tubing (300mm + 50mm Point)',totalUprights,[1]));
    const clips=[];let pegsObj=null;
    if(nettingType!=='none'){joiners.push({sku:'Cable Ties Pack of 100',required_qty:1,packs:{100:1},total_supplied:100,leftover:99});const perimMm=2*(widthMm+lengthMm);const clipsReq=Math.max(1,Math.ceil((2*perimMm)/CLIP_SPACING_MM));clips.push(packSelection('Netting Clips Black (19mm)',clipsReq,[25,50,100,1000]));if(pegType!=='none'){const pegsReq=Math.max(4,Math.ceil(perimMm/PEG_SPACING_MM));pegsObj=packSelection(pegType==='u_peg'?'U-pegs':'Galvanised Steel Garden Pegs',pegsReq,pegType==='u_peg'?[25,50,100]:GALV_PEG_PACKS);}}
    let netting=null,nettingSec=null;
    if(nettingType!=='none'){netting=chooseRoofNetting(nettingType,widthMm,lengthMm);if(nettingType==='anti_bird_black'){nettingSec=chooseSideNetting('poultry_fruit',widthMm,lengthMm);}else{nettingSec=chooseSideNetting(nettingType,widthMm,lengthMm);}}
    if(isSingleRollNetting(netting,nettingSec))notices.push('For cages measuring less than 2m², the netting will be supplied as one continuous 2m-wide piece. This will need to be cut to the required lengths on delivery to cover both the top and sides of the cage.');
    const doorSummary=doorEnabled?{wall:'front',position:doorPos,width_mm:750,count:doorCount}:null;
    return{cage_type:'walk_in',dimensions_mm:{height:achievedH,width:widthMm,length:lengthMm,requested_height:heightMm,requested_width:reqW,requested_length:reqL,upright_pole_length:uprightPole},joiner_system:'walk_in_19mm',poles:[],pole_packs:polePacks,joiners,clips,pegs:pegsObj,netting,netting_secondary:nettingSec,notices,summary:{achievable_height_mm:achievedH,upright_pole_length_mm:uprightPole,corner_uprights:4,internal_uprights:2*K+2*M+K*M,total_uprights:totalUprights,corner_joiners:cornerCount,tee_joiners:teeCount,cross_joiners:crossCount,total_joiners_required:cornerCount+teeCount+crossCount,cross_braces:M,cross_brace_positions_mm:bracePos,internal_support_rows:K,internal_row_positions_mm:rowPos,length_bar_pieces_mm:lenBayPoles,width_bar_pieces_mm:widBayPoles,length_bar_join_positions_mm:[],width_bar_join_positions_mm:[],corner_braces:cornerBraces?4:0,door:doorSummary}};
  }

  function calculateLow19mm({heightMm,widthMm,lengthMm,nettingType='none',pegType='u_peg',cornerBraces=true}){
    const{pole:uprightPole,achieved:achievedH}=low19mmHeightToPole(heightMm);
    const reqW=widthMm,reqL=lengthMm;
    widthMm=snapToAchievable(widthMm,LOW_19MM_HORIZ_LENGTHS);lengthMm=snapToAchievable(lengthMm,LOW_19MM_HORIZ_LENGTHS);
    const notices=[];
    if(widthMm!==reqW||lengthMm!==reqL)notices.push(`Footprint adjusted to ${widthMm/1000}m × ${lengthMm/1000}m (you requested ${reqW/1000}m × ${reqL/1000}m). Dimensions snapped to nearest size achievable with stocked pole lengths.`);
    if(achievedH!==heightMm)notices.push(`Erected height adjusted to ${achievedH}mm (nearest achievable with a ${uprightPole}mm pole).`);
    const lenBayPoles=snapSpanToPoles(lengthMm,LOW_19MM_HORIZ_LENGTHS,'length');
    const widBayPoles=snapSpanToPoles(widthMm,LOW_19MM_HORIZ_LENGTHS,'width');
    function joinPos19(poles){const pos=[];let acc=0;for(const p of poles.slice(0,-1)){acc+=p;pos.push(acc);}return pos;}
    const bracePos=joinPos19(lenBayPoles);
    const rowPos=joinPos19(widBayPoles);
    const K=rowPos.length;
    const M=bracePos.length;
    const totalUprights=4+2*K+2*M+K*M;
    const poleQtys={};poleQtys[uprightPole]=(poleQtys[uprightPole]||0)+totalUprights;
    const addPoles=(list,qty)=>list.forEach(p=>{poleQtys[p]=(poleQtys[p]||0)+qty;});
    addPoles(lenBayPoles,2+K);addPoles(widBayPoles,2+M);
    const polePacks=Object.entries(poleQtys).sort(([a],[b])=>Number(b)-Number(a)).map(([len,qty])=>packSelection(`19mm aluminium tube — ${len}mm`,qty,POLE_PACK_SIZES));
    const cornerCount=4,teeCount=2*K+2*M,crossCount=K*M;
    const joiners=[];
    joiners.push(packSelection('19mm Joiner Corner For Fruit and Vegetable Cages',cornerCount,[1]));
    if(teeCount>0)joiners.push(packSelection('19mm Joiner Tee (For Fruit and Vegetable Cage Connector)',teeCount,[1]));
    if(crossCount>0)joiners.push(packSelection('19mm Joiner Cross For Fruit and Vegetable Cages',crossCount,[1]));
    if(cornerBraces)joiners.push(packSelection('Corner Brace kit for Walk-In Cages',1,[1]));
    const clips=[];let pegsObj=null;
    if(nettingType!=='none'){const perimMm=2*(widthMm+lengthMm);const clipsReq=Math.max(1,Math.ceil(perimMm/CLIP_SPACING_MM));clips.push(packSelection('Netting Clips Black (19mm)',clipsReq,[25,50,100,1000]));if(pegType!=='none'){const pegsReq=Math.max(4,Math.ceil(perimMm/PEG_SPACING_MM));pegsObj=packSelection(pegType==='u_peg'?'U-pegs':'Galvanised Steel Garden Pegs',pegsReq,pegType==='u_peg'?U_PEG_PACKS:GALV_PEG_PACKS);}}
    let netting=null;
    if(nettingType!=='none')netting=chooseNetting(nettingType,achievedH,widthMm,lengthMm);
    return{cage_type:'low_19mm',dimensions_mm:{height:achievedH,width:widthMm,length:lengthMm,requested_height:heightMm,requested_width:reqW,requested_length:reqL,upright_pole_length:uprightPole},joiner_system:'low_19mm_19mm',poles:[],pole_packs:polePacks,joiners,clips,pegs:pegsObj,netting,netting_secondary:null,notices,summary:{achievable_height_mm:achievedH,upright_pole_length_mm:uprightPole,corner_uprights:4,internal_uprights:2*K+2*M+K*M,total_uprights:totalUprights,corner_joiners:cornerCount,tee_joiners:teeCount,cross_joiners:crossCount,total_joiners_required:cornerCount+teeCount+crossCount,cross_braces:M,cross_brace_positions_mm:bracePos,internal_support_rows:K,internal_row_positions_mm:rowPos,length_bar_pieces_mm:lenBayPoles,width_bar_pieces_mm:widBayPoles,length_bar_join_positions_mm:[],width_bar_join_positions_mm:[],corner_braces:cornerBraces?4:0,door:null}};
  }

  function calculatePremiumWalkIn({widthMm,lengthMm,nettingType='none',pegType='galvanised_steel',
                                    doorCount=0,allenKey=true}){
    const reqW=widthMm,reqL=lengthMm;
    widthMm=snapToAchievable(widthMm,PREMIUM_HORIZ_LENGTHS);lengthMm=snapToAchievable(lengthMm,PREMIUM_HORIZ_LENGTHS);
    const notices=[];
    if(widthMm!==reqW||lengthMm!==reqL)notices.push(`Footprint adjusted to ${widthMm/1000}m × ${lengthMm/1000}m (you requested ${reqW/1000}m × ${reqL/1000}m). Dimensions snapped to nearest size achievable with stocked pole lengths.`);

    const achievedH=PREMIUM_HEIGHT_MM, uprightPole=PREMIUM_POLE_MM;

    const lenBayPoles=snapSpanToPoles(lengthMm,PREMIUM_HORIZ_LENGTHS,'length');
    const widBayPoles=snapSpanToPoles(widthMm,PREMIUM_HORIZ_LENGTHS,'width');
    function joinPositions(poles){const pos=[];let acc=0;for(const p of poles.slice(0,-1)){acc+=p;pos.push(acc);}return pos;}
    const bracePos=joinPositions(lenBayPoles),rowPos=joinPositions(widBayPoles);
    const K=rowPos.length,M=bracePos.length;

    const doorEnabled=doorCount>0;
    const dHalf=375;
    const doorPos=doorEnabled?Math.max(0,Math.min(1,(dHalf<=lengthMm?dHalf:-dHalf)/lengthMm)):0;

    const totalUprights=4+2*K+2*M+K*M;
    const cornerCount=4,teeCount=2*K+2*M,crossCount=K*M;
    const endBungQty=teeCount+crossCount;

    const poleQtys={};
    poleQtys[uprightPole]=(poleQtys[uprightPole]||0)+totalUprights;
    const addPoles=(list,qty)=>list.forEach(p=>{poleQtys[p]=(poleQtys[p]||0)+qty;});
    addPoles(lenBayPoles,2+K); addPoles(widBayPoles,2+M);
    const polePacks=Object.entries(poleQtys).sort(([a],[b])=>Number(b)-Number(a))
      .map(([len,qty])=>packSelection(`27mm premium aluminium tube — ${len}mm`,qty,POLE_PACK_SIZES));

    const joiners=[];
    joiners.push(packSelection('Premium Cage Corner Joiner (27mm)',cornerCount,[1]));
    if(teeCount>0)joiners.push(packSelection('Premium Cage Tee Joiner (27mm)',teeCount,[1]));
    if(crossCount>0)joiners.push(packSelection('Premium Cage Cross Joiner (27mm)',crossCount,[1]));
    if(endBungQty>0)joiners.push(packSelection('Premium Cage End Bung (27mm)',endBungQty,[1]));
    if(allenKey)joiners.push(packSelection('Premium Cage Allen Key',1,[1]));
    if(doorEnabled)joiners.push(packSelection('Premium Cage Door Kit',doorCount,[1]));

    const clips=[]; let pegsObj=null;
    if(nettingType!=='none'){
      clips.push(packSelection('Premium Cage Net Clamp (27mm)',1,[1]));
      joiners.push({sku:'Premium Cage Cable Ties Pack of 100',required_qty:1,packs:{100:1},total_supplied:100,leftover:99});
      if(pegType!=='none'){
        const perimMm=2*(widthMm+lengthMm);
        const pegsReq=Math.max(4,Math.ceil(perimMm/PEG_SPACING_MM));
        const pegSku=pegType==='u_peg'?'U-pegs':'Galvanised Steel Garden Pegs';
        const pegPacks=pegType==='u_peg'?[25,50,100]:GALV_PEG_PACKS;
        pegsObj=packSelection(pegSku,pegsReq,pegPacks);
      }
    }

    let netting=null,nettingSec=null;
    if(nettingType!=='none'){
      netting=chooseRoofNetting(nettingType,widthMm,lengthMm);
      if(nettingType==='anti_bird_black'){nettingSec=chooseSideNetting('poultry_fruit',widthMm,lengthMm);}
      else{nettingSec=chooseSideNetting(nettingType,widthMm,lengthMm);}
    }
    if(isSingleRollNetting(netting,nettingSec))notices.push('For cages measuring less than 2m², the netting will be supplied as one continuous 2m-wide piece. This will need to be cut to the required lengths on delivery to cover both the top and sides of the cage.');

    const doorSummary=doorEnabled?{wall:'front',position:doorPos,width_mm:750,count:doorCount}:null;
    return{cage_type:'premium_walk_in',dimensions_mm:{height:achievedH,width:widthMm,length:lengthMm,requested_height:PREMIUM_HEIGHT_MM,requested_width:reqW,requested_length:reqL,upright_pole_length:uprightPole},joiner_system:'premium_27mm',poles:[],pole_packs:polePacks,joiners,clips,pegs:pegsObj,netting,netting_secondary:nettingSec,notices,summary:{achievable_height_mm:achievedH,upright_pole_length_mm:uprightPole,corner_uprights:4,internal_uprights:2*K+2*M+K*M,total_uprights:totalUprights,corner_joiners:cornerCount,tee_joiners:teeCount,cross_joiners:crossCount,total_joiners_required:cornerCount+teeCount+crossCount,cross_braces:M,cross_brace_positions_mm:bracePos,internal_support_rows:K,internal_row_positions_mm:rowPos,length_bar_pieces_mm:lenBayPoles,width_bar_pieces_mm:widBayPoles,length_bar_join_positions_mm:[],width_bar_join_positions_mm:[],corner_braces:0,end_bungs:endBungQty,door:doorSummary}};
  }

  function calculate(cageType,params){
    switch(cageType){
      case 'low_fruit_veg': return calculateLowFruitVeg(params);
      case 'walk_in': return calculateWalkIn(params);
      case 'low_19mm': return calculateLow19mm(params);
      case 'premium_walk_in': return calculatePremiumWalkIn(params);
      default: throw new Error('Unsupported cage type.');
    }
  }

  function _vid(entry) {
    if (entry === null || entry === undefined) return null;
    const n = typeof entry === 'object' ? Number(entry.variantId) : Number(entry);
    return Number.isSafeInteger(n) && n > 0 ? n : null;
  }

  function _resolveSkuOrPack(sku, map) {
    map = map || CFG.skuVariantMap || {};
    const vid = _vid(map[sku]);
    if (vid) return { sku, variantId: vid, packSize: 1 };
    const prefix = sku + ' — pack of ';
    let bestSize = null;
    for (const k of Object.keys(map)) {
      if (k.startsWith(prefix) && _vid(map[k])) {
        const n = Number(k.slice(prefix.length));
        if (Number.isSafeInteger(n) && n > 0 && (bestSize === null || n < bestSize)) bestSize = n;
      }
    }
    if (bestSize === null) return null;
    const packKey = `${sku} — pack of ${bestSize}`;
    return { sku: packKey, variantId: _vid(map[packKey]), packSize: bestSize };
  }

  function cageOrderProperties(bom){
    const dims=bom.dimensions_mm||{};
    return{
      _cage_calculator:'true',
      _cage_type:bom.cage_type,
      _cage_dimensions_mm:`${dims.width}x${dims.length}x${dims.height}`,
      _cage_netting_type:bom.netting?bom.netting.netting_type:'none',
    };
  }

  function resolveCartItems(bom){
    const map=CFG.skuVariantMap||{},items=[],unmapped=[];
    const properties=cageOrderProperties(bom);
    function addItem(skuDesc,qty){const variantId=_vid(map[skuDesc]);if(variantId){const existing=items.find(i=>i.id===variantId);if(existing)existing.quantity+=Number(qty);else items.push({id:variantId,quantity:Number(qty),properties});return;}unmapped.push({sku:skuDesc,qty});}
    function addItemOrPackFallback(sku,qty){
      const resolved=_resolveSkuOrPack(sku,map);
      if(!resolved){unmapped.push({sku,qty});return;}
      const packsNeeded=resolved.packSize===1?Number(qty):Math.ceil(Number(qty)/resolved.packSize);
      const existing=items.find(i=>i.id===resolved.variantId);
      if(existing)existing.quantity+=packsNeeded;else items.push({id:resolved.variantId,quantity:packsNeeded,properties});
    }
    for(const p of(bom.pole_packs||[])){for(const[sz,ct]of Object.entries(p.packs||{})){if(ct>0){if(Number(sz)===1)addItemOrPackFallback(p.sku,ct);else addItem(`${p.sku} — pack of ${sz}`,ct);}}}
    for(const j of(bom.joiners||[])){for(const[sz,ct]of Object.entries(j.packs||{})){if(ct>0){if(Number(sz)===1)addItemOrPackFallback(j.sku,ct);else addItem(`${j.sku} — pack of ${sz}`,ct);}}}
    for(const c of(bom.clips||[])){for(const[sz,ct]of Object.entries(c.packs||{})){if(ct>0){if(Number(sz)===1)addItemOrPackFallback(c.sku,ct);else addItem(`${c.sku} — pack of ${sz}`,ct);}}}
    if(bom.pegs){const p=bom.pegs;for(const[sz,ct]of Object.entries(p.packs||{})){if(ct>0){if(Number(sz)===1)addItemOrPackFallback(p.sku,ct);else addItem(`${p.sku} — pack of ${sz}`,ct);}}}
    if(bom.netting)addNettingItem(bom.netting,map,items,unmapped,properties);
    if(bom.netting_secondary)addNettingItem(bom.netting_secondary,map,items,unmapped,properties);
    return{items,unmapped};
  }

  function mmToM(v){
    const m=v/1000;
    return Number.isInteger(m)?`${m}m`:`${+m.toFixed(3)}m`;
  }

  function addNettingItem(n, map, items, unmapped, properties){
    const primary=`${n.display_name} — ${mmToM(n.chosen_width_mm)} × ${n.chosen_length_m}m`;
    if(tryAddNetting(primary, 1, map, items, properties)) return;
    const transposedW=n.chosen_length_m*1000, transposedL=n.chosen_width_mm/1000;
    if(Number.isInteger(transposedW) && Number.isInteger(transposedL)){
      const transposed=`${n.display_name} — ${mmToM(transposedW)} × ${transposedL}m`;
      if(tryAddNetting(transposed, 1, map, items, properties)) return;
    }
    const perMetre=`${n.display_name} — ${mmToM(n.chosen_width_mm)} per metre`;
    if(tryAddNetting(perMetre, n.chosen_length_m, map, items, properties)) return;
    if(Number.isInteger(transposedW)){
      const perMetreT=`${n.display_name} — ${mmToM(transposedW)} per metre`;
      if(tryAddNetting(perMetreT, transposedL, map, items, properties)) return;
    }
    unmapped.push({sku: primary, qty: 1});
  }

  function tryAddNetting(skuDesc, qty, map, items, properties){
    const variantId=_vid(map[skuDesc]);
    if(!variantId) return false;
    const existing=items.find(i=>i.id===variantId);
    if(existing) existing.quantity+=Number(qty);
    else items.push({id:variantId,quantity:Number(qty),properties});
    return true;
  }

  function safeCartEndpoint(value) {
    try {
      const url = new URL(value || '/cart/add.js', location.origin);
      return url.origin === location.origin ? url.pathname + url.search : '/cart/add.js';
    } catch { return '/cart/add.js'; }
  }

  async function addToCart(items){
    const res=await fetch(safeCartEndpoint(CFG.addToCartUrl),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await res.json();
    if(!res.ok)throw new Error(data.description||data.message||`Cart error ${res.status}`);
    return data;
  }

  function _isDangerousUrl(value){
    try{
      const url=new URL(value,location.origin);
      return url.protocol==='javascript:'||url.protocol==='data:';
    }catch{
      return true;
    }
  }

  function _sanitizeSectionDoc(doc){
    const REMOVE_TAGS=new Set(['SCRIPT','IFRAME','OBJECT','EMBED','META']);
    const URL_ATTRS=new Set(['href','xlink:href','src','action','formaction']);
    const els=[doc.body,...doc.body.querySelectorAll('*')];
    for(const el of els){
      if(REMOVE_TAGS.has(el.tagName.toUpperCase())){el.remove();continue;}
      for(const attr of [...el.attributes]){
        const name=attr.name.toLowerCase();
        if(name.startsWith('on')){el.removeAttribute(attr.name);continue;}
        if(URL_ATTRS.has(name)&&_isDangerousUrl(attr.value)){
          el.removeAttribute(attr.name);
        }
      }
    }
    return doc;
  }

  async function _refreshCartUI(){
    try{
      const res=await fetch('/cart.js',{headers:{'Accept':'application/json'}});
      if(!res.ok){console.warn('[GN cage calculator] /cart.js returned',res.status);return;}
      const cart=await res.json();
      const count=cart.item_count;

      const badgeSelectors=['.cart-count','.cart__count','.header__cart-count',
       '#CartCount','.js-cart-count','.cart-items-count',
       '.cart-link__bubble','.cart__badge'];
      badgeSelectors.forEach(s=>{
        document.querySelectorAll(s).forEach(el=>{el.textContent=count;});
      });

      const dataCountEls=document.querySelectorAll('[data-cart-count]');
      dataCountEls.forEach(el=>{el.dataset.cartCount=count;});
      const dataItemCountEls=document.querySelectorAll('[data-cart-item-count]');
      dataItemCountEls.forEach(el=>{el.dataset.cartItemCount=count;});

      const bubbleEls=document.querySelectorAll('.cart-count-bubble');
      bubbleEls.forEach(el=>{
        if(count>0){el.removeAttribute('hidden');}else{el.setAttribute('hidden','');}
        const spans=el.querySelectorAll('span');
        if(spans[0])spans[0].textContent=count;
        if(spans[1])spans[1].textContent=`${count} item${count!==1?'s':''}`;
      });

      const safeSectionId=/^[a-z0-9_-]+$/i;
      const configuredIds=Array.isArray(CFG.cartSectionIds)?CFG.cartSectionIds.filter(id=>typeof id==='string'&&safeSectionId.test(id)):[];
      const sectionIds=[...new Set(['cart-icon-bubble','cart-notification','cart-drawer',...configuredIds])];
      fetch(`/?sections=${sectionIds.join(',')}`,{headers:{'Accept':'application/json'}})
        .then(r=>r.ok?r.json():null)
        .then(sections=>{
          if(!sections){console.warn(`[GN cage calculator] Section Rendering fetch for ${sectionIds.join(',')} failed.`);return;}
          Object.entries(sections).forEach(([id,html])=>{
            if(!safeSectionId.test(id))return;
            if(typeof html!=='string')return;
            const doc=new DOMParser().parseFromString(html,'text/html');
            _sanitizeSectionDoc(doc);

            const wrapperEl=document.getElementById(`shopify-section-${id}`);
            if(wrapperEl){
              const inner=doc.getElementById(`shopify-section-${id}`);
              wrapperEl.replaceChildren(...(inner?inner.childNodes:doc.body.childNodes));
              return;
            }

            const bareEl=document.getElementById(id)||document.querySelector(`[data-section="${id}"]`);
            if(!bareEl)return;
            const innerMatch=doc.getElementById(id)||doc.querySelector(`[data-section="${id}"]`);
            if(innerMatch)bareEl.replaceWith(innerMatch);
            else bareEl.replaceChildren(...doc.body.childNodes);
          });
        })
        .catch(err=>console.warn('[GN cage calculator] Section Rendering fetch errored:',err));

      ['cart:refresh','cart:updated','cart:change','theme:cart:open'].forEach(name=>{
        document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:{cart}}));
      });
    }catch(err){console.error('[GN cage calculator] _refreshCartUI failed:',err);}
  }

  const CAGE_TYPES=[
    {id:'low_fruit_veg',display_name:'Low Fruit & Veg Cage (13mm/16mm)',description:'Modular low cage with 16mm uprights, 13mm horizontal frame, single drape netting.',features:{joiner_system:true,door:false,extras:false,netting_types:LOW_FV_NETTING_TYPES,pole_to_height:POLE_TO_CAGE_HEIGHT_MM}},
    {id:'walk_in',display_name:'Walk-In Cage (19mm)',description:'Tall 19mm aluminium frame, optional door, separate roof + side-wrap netting. Fixed 1.9m erected height.',features:{joiner_system:false,door:true,extras:true,netting_types:WALKIN_NETTING_TYPES,fixed_height_mm:1900}},
    {id:'low_19mm',display_name:'Low Cage (19mm)',description:'19mm aluminium frame, no door. Available in 1.2m and 1.554m erected heights.',features:{joiner_system:false,door:false,extras:true,netting_types:LOW_19MM_NETTING_TYPES,pole_to_height:LOW_19MM_POLE_TO_HEIGHT_MM}},
    {id:'premium_walk_in',display_name:'Premium Walk-In Cage (27mm)',description:'27mm black aluminium frame with premium joiners and allen key fixings. Fixed 1.9m erected height. Optional door kit.',features:{joiner_system:false,door:true,extras:true,netting_types:PREMIUM_NETTING_TYPES,fixed_height_mm:PREMIUM_HEIGHT_MM,premium:true}},
  ];
  const NETTING_OPTIONS=[{value:'none',label:'No netting'},...Object.entries(NETTING_CATALOGUE).map(([k,v])=>({value:k,label:v.display_name}))];
  const JOINER_SYSTEMS=[{value:'three_variant',label:'13/16mm Joiners'},{value:'build_a_ball',label:'Build-A-Ball'}];
  const PEG_TYPES=[{value:'u_peg',label:'Galvanised Steel U Pins'},{value:'galvanised_steel',label:'Galvanised Steel Garden Pegs'},{value:'none',label:'No Pegs'}];

  const C = {
    upright:        '#3b82f6',
    lengthBar:      '#2f855a',
    widthBar:       '#a16207',
    joinerCorner:   '#7c3aed',
    joinerTee:      '#16a34a',
    joinerCross:    '#ea580c',
    joinerUpright:  '#111111',
    door:           '#f4951b',
    ground:         '#9ca3af',
    netting:        'rgba(167,243,208,0.35)',
    nettingStroke:  '#6ee7b7',
    peg:            '#92400e',
    dimensionLine:  '#9ca3af',
    dimensionLabel: '#4b5563',
  };

  function fmtMm(v){return v>=1000?`${+(v/1000).toFixed(3).replace(/\.?0+$/,'')} m`:`${Math.round(v)} mm`;}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');}

  function _cornerMarker(cx, cy) {
    return `<circle cx="${cx}" cy="${cy}" r="7" fill="${C.joinerCorner}" stroke="#fff" stroke-width="1.5"/>`;
  }
  function _teeMarker(cx, cy) {
    const r = 5.5;
    return `<rect x="${(cx-r).toFixed(1)}" y="${(cy-r).toFixed(1)}" width="${(r*2).toFixed(1)}" height="${(r*2).toFixed(1)}" fill="${C.joinerTee}" stroke="#fff" stroke-width="1.5"/>`;
  }
  function _crossMarker(cx, cy) {
    const r = 6;
    return `<rect x="${(cx-r).toFixed(1)}" y="${(cy-r).toFixed(1)}" width="${(r*2).toFixed(1)}" height="${(r*2).toFixed(1)}" fill="${C.joinerCross}" stroke="#fff" stroke-width="1.5" transform="rotate(45 ${cx} ${cy})"/>`;
  }
  function _ballMarker(cx, cy) {
    return `<circle cx="${cx}" cy="${cy}" r="6" fill="${C.joinerTee}" stroke="#fff" stroke-width="1.5"/>`;
  }

  function buildDiagramSvg(bom) {
    const dims = bom.dimensions_mm;
    const s = bom.summary;
    const W = dims.width, L = dims.length, H = s.achievable_height_mm;
    const poleMm = s.upright_pole_length_mm || H;
    const inGnd = poleMm - H;
    const rowPos   = s.internal_row_positions_mm || [];
    const bracePos = s.cross_brace_positions_mm  || [];
    const lenJoins = s.length_bar_join_positions_mm || [];
    const widJoins = s.width_bar_join_positions_mm  || [];
    const hasNetting = !!bom.netting;
    const hasPegs = !!bom.pegs;
    const isBuildABall = (bom.joiner_system === 'build_a_ball');

    const SVG_W = 880, LEFT_PAD = 55, RIGHT_PAD = 70, TOP_PAD = 40, SECTION_GAP = 40, BELOW_ELEV = 70;
    const DRAW_W = SVG_W - LEFT_PAD - RIGHT_PAD;
    const planScale = Math.min(DRAW_W / L, 280 / W);
    const planW = L * planScale, planH = W * planScale;
    const planX = LEFT_PAD + (DRAW_W - planW) / 2;
    const planY = TOP_PAD + 18;

    const elevW = DRAW_W, elevScale = DRAW_W / L;
    const IN_GND_PX = Math.max(20, Math.min(30, inGnd * 0.03));
    const elevH = Math.min(160, Math.max(120, H * elevScale));
    const elevX = LEFT_PAD;
    const elevTitleY = planY + planH + SECTION_GAP;
    const elevY = elevTitleY + 22;
    const groundY = elevY + elevH;
    const belowGndY = groundY + IN_GND_PX;
    const SVG_H = belowGndY + BELOW_ELEV;

    const parts = [`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${SVG_W} ${SVG_H}" style="display:block;width:100%;height:auto">`];

    parts.push(`<text x="${planX+planW/2}" y="${TOP_PAD-4}" text-anchor="middle" font-size="12" fill="${C.dimensionLabel}" font-weight="600" font-family="sans-serif">Top plan</text>`);
    parts.push(`<rect x="${planX}" y="${planY}" width="${planW}" height="${planH}" fill="${hasNetting ? C.netting : '#f3f4f6'}" stroke="none"/>`);
    parts.push(`<line x1="${planX}" y1="${planY}" x2="${planX+planW}" y2="${planY}" stroke="${C.lengthBar}" stroke-width="2.5"/>`);
    parts.push(`<line x1="${planX}" y1="${planY+planH}" x2="${planX+planW}" y2="${planY+planH}" stroke="${C.lengthBar}" stroke-width="2.5"/>`);
    parts.push(`<line x1="${planX}" y1="${planY}" x2="${planX}" y2="${planY+planH}" stroke="${C.widthBar}" stroke-width="2.5"/>`);
    parts.push(`<line x1="${planX+planW}" y1="${planY}" x2="${planX+planW}" y2="${planY+planH}" stroke="${C.widthBar}" stroke-width="2.5"/>`);

    bracePos.forEach(xmm => {
      const x = planX + xmm * planScale;
      parts.push(`<line x1="${x}" y1="${planY}" x2="${x}" y2="${planY+planH}" stroke="${C.widthBar}" stroke-width="2"/>`);
    });
    rowPos.forEach(ymm => {
      const y = planY + ymm * planScale;
      parts.push(`<line x1="${planX}" y1="${y}" x2="${planX+planW}" y2="${y}" stroke="${C.lengthBar}" stroke-width="2"/>`);
    });

    const door = s.door;
    if (door) {
      const dWmm = door.width_mm||750, dPos = door.position||0.5, wall = door.wall||'front';
      if (['front','back'].includes(wall)) {
        const cx = planX + L*dPos*planScale, hw = dWmm/2*planScale, dy = wall==='front'?planY:planY+planH;
        parts.push(`<line x1="${cx-hw}" y1="${dy}" x2="${cx+hw}" y2="${dy}" stroke="${C.door}" stroke-width="5" stroke-linecap="round"/>`);
        parts.push(`<circle cx="${cx+hw}" cy="${dy}" r="5" fill="${C.joinerUpright}" stroke="#fff" stroke-width="1.2"/>`);
      } else {
        const cz = planY + W*dPos*planScale, hw = dWmm/2*planScale, dx = wall==='left'?planX:planX+planW;
        parts.push(`<line x1="${dx}" y1="${cz-hw}" x2="${dx}" y2="${cz+hw}" stroke="${C.door}" stroke-width="5" stroke-linecap="round"/>`);
        parts.push(`<circle cx="${dx}" cy="${cz+hw}" r="5" fill="${C.joinerUpright}" stroke="#fff" stroke-width="1.2"/>`);
      }
    }

    lenJoins.forEach(xmm => {
      const x = planX + xmm * planScale;
      parts.push(`<line x1="${x}" y1="${planY-6}" x2="${x}" y2="${planY+6}" stroke="#fff" stroke-width="3.5"/>`);
      parts.push(`<line x1="${x}" y1="${planY-6}" x2="${x}" y2="${planY+6}" stroke="${C.dimensionLine}" stroke-width="1.8"/>`);
      parts.push(`<line x1="${x}" y1="${planY+planH-6}" x2="${x}" y2="${planY+planH+6}" stroke="#fff" stroke-width="3.5"/>`);
      parts.push(`<line x1="${x}" y1="${planY+planH-6}" x2="${x}" y2="${planY+planH+6}" stroke="${C.dimensionLine}" stroke-width="1.8"/>`);
    });
    widJoins.forEach(ymm => {
      const y = planY + ymm * planScale;
      parts.push(`<line x1="${planX-6}" y1="${y}" x2="${planX+6}" y2="${y}" stroke="#fff" stroke-width="3.5"/>`);
      parts.push(`<line x1="${planX-6}" y1="${y}" x2="${planX+6}" y2="${y}" stroke="${C.dimensionLine}" stroke-width="1.8"/>`);
      parts.push(`<line x1="${planX+planW-6}" y1="${y}" x2="${planX+planW+6}" y2="${y}" stroke="#fff" stroke-width="3.5"/>`);
      parts.push(`<line x1="${planX+planW-6}" y1="${y}" x2="${planX+planW+6}" y2="${y}" stroke="${C.dimensionLine}" stroke-width="1.8"/>`);
    });

    const allX = [...new Set([0,...lenJoins,...bracePos,L])].sort((a,b)=>a-b);
    const lenJoinSet = new Set(lenJoins);
    if (allX.length > 2) {
      for (let i=0;i<allX.length-1;i++) {
        const x1=planX+allX[i]*planScale,x2=planX+allX[i+1]*planScale;
        const isConnX=lenJoinSet.has(allX[i]);
        const lblX=fmtMm(allX[i+1]-allX[i]).replace(/( mm| m| ft)$/,isConnX?'e$1':'$1');
        parts.push(`<line x1="${x1}" y1="${planY-4}" x2="${x1}" y2="${planY-12}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${x2}" y1="${planY-4}" x2="${x2}" y2="${planY-12}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${x1}" y1="${planY-8}" x2="${x2}" y2="${planY-8}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<text x="${(x1+x2)/2}" y="${planY-14}" text-anchor="middle" font-size="9" fill="${C.dimensionLabel}" font-family="sans-serif">${esc(lblX)}</text>`);
      }
    }
    const allY = [...new Set([0,...widJoins,...rowPos,W])].sort((a,b)=>a-b);
    const widJoinSet = new Set(widJoins);
    if (allY.length > 2) {
      for (let i=0;i<allY.length-1;i++) {
        const y1=planY+allY[i]*planScale,y2=planY+allY[i+1]*planScale,midY=(y1+y2)/2;
        const isConnY=widJoinSet.has(allY[i]);
        const lblY=fmtMm(allY[i+1]-allY[i]).replace(/( mm| m| ft)$/,isConnY?'e$1':'$1');
        parts.push(`<line x1="${planX-4}" y1="${y1}" x2="${planX-12}" y2="${y1}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${planX-4}" y1="${y2}" x2="${planX-12}" y2="${y2}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${planX-8}" y1="${y1}" x2="${planX-8}" y2="${y2}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<text x="${planX-10}" y="${midY}" text-anchor="middle" font-size="9" fill="${C.dimensionLabel}" font-family="sans-serif" transform="rotate(-90 ${planX-10} ${midY})">${esc(lblY)}</text>`);
      }
    }

    [[planX,planY],[planX+planW,planY],[planX,planY+planH],[planX+planW,planY+planH]].forEach(([cx,cy]) => {
      parts.push(isBuildABall ? _ballMarker(cx,cy) : _cornerMarker(cx,cy));
    });
    rowPos.forEach(p => {
      const y = planY + p * planScale;
      parts.push(isBuildABall ? _ballMarker(planX,y) : _teeMarker(planX,y));
      parts.push(isBuildABall ? _ballMarker(planX+planW,y) : _teeMarker(planX+planW,y));
    });
    bracePos.forEach(p => {
      const x = planX + p * planScale;
      parts.push(isBuildABall ? _ballMarker(x,planY) : _teeMarker(x,planY));
      parts.push(isBuildABall ? _ballMarker(x,planY+planH) : _teeMarker(x,planY+planH));
    });
    rowPos.forEach(rp => bracePos.forEach(bp => {
      const cx = planX+bp*planScale, cy = planY+rp*planScale;
      parts.push(isBuildABall ? _ballMarker(cx,cy) : _crossMarker(cx,cy));
    }));

    if (s.corner_braces > 0) {
      const br = Math.min(planW, planH) * 0.15;
      const cbCornerDefs = [
        { cx: planX,       cy: planY,       dx:  1,  dy:  1 },
        { cx: planX+planW, cy: planY,       dx: -1,  dy:  1 },
        { cx: planX,       cy: planY+planH, dx:  1,  dy: -1 },
        { cx: planX+planW, cy: planY+planH, dx: -1,  dy: -1 },
      ];
      cbCornerDefs.forEach(({ cx, cy, dx, dy }) => {
        const x1 = cx + dx * br, y1 = cy;
        const x2 = cx,           y2 = cy + dy * br;
        parts.push(`<path d="M${x1.toFixed(1)},${y1.toFixed(1)} Q${cx.toFixed(1)},${cy.toFixed(1)} ${x2.toFixed(1)},${y2.toFixed(1)}" fill="none" stroke="#dc2626" stroke-width="2.5" stroke-linecap="round"/>`);
        parts.push(`<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.7"/>`);
      });
    }
    if (hasPegs) {
      const topCount = Math.max(2, Math.ceil(L/PEG_SPACING_MM)+1);
      const sideCount = Math.max(2, Math.ceil(W/PEG_SPACING_MM)+1);
      function planPeg(px,py){parts.push(`<polygon points="${px-3},${py-6} ${px+3},${py-6} ${px},${py-1}" fill="${C.peg}"/>`);}
      for(let i=0;i<topCount;i++){const t=i/(topCount-1);planPeg(planX+t*planW,planY);planPeg(planX+t*planW,planY+planH);}
      for(let i=0;i<sideCount;i++){const t=i/(sideCount-1);planPeg(planX,planY+t*planH);planPeg(planX+planW,planY+t*planH);}
    }

    parts.push(`<line x1="${planX}" y1="${planY+planH+14}" x2="${planX+planW}" y2="${planY+planH+14}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<text x="${planX+planW/2}" y="${planY+planH+24}" text-anchor="middle" font-size="10" fill="${C.dimensionLabel}" font-family="sans-serif">Length ${esc(fmtMm(L))}</text>`);
    const wlx=planX-36,wmy=planY+planH/2;
    parts.push(`<text x="${wlx}" y="${wmy}" text-anchor="middle" font-size="10" fill="${C.dimensionLabel}" font-family="sans-serif" transform="rotate(-90 ${wlx} ${wmy})">Width ${esc(fmtMm(W))}</text>`);

    parts.push(`<text x="${LEFT_PAD+DRAW_W/2}" y="${elevTitleY+14}" text-anchor="middle" font-size="12" fill="${C.dimensionLabel}" font-weight="600" font-family="sans-serif">Side elevation</text>`);

    for(let hx=elevX-10;hx<elevX+elevW+10;hx+=9)
      parts.push(`<line x1="${hx}" y1="${groundY}" x2="${hx-7}" y2="${groundY+10}" stroke="${C.ground}" stroke-width="0.9" opacity="0.5"/>`);
    parts.push(`<line x1="${elevX-10}" y1="${groundY}" x2="${elevX+elevW+10}" y2="${groundY}" stroke="${C.ground}" stroke-width="1.8"/>`);
    parts.push(`<line x1="${elevX}" y1="${elevY}" x2="${elevX+elevW}" y2="${elevY}" stroke="${C.lengthBar}" stroke-width="2.5"/>`);
    if (hasNetting) parts.push(`<rect x="${elevX}" y="${elevY}" width="${elevW}" height="${elevH}" fill="${C.netting}" stroke="${C.nettingStroke}" stroke-width="1.2" stroke-dasharray="3,2"/>`);

    const lenP = s.length_bar_pieces_mm || [];
    const lenPConns = new Set(s.length_bar_connectors_mm || []);
    if (lenP.length > 1) {
      const fmtP=p=>{const f=fmtMm(p);return lenPConns.has(p)?f.replace(/( mm| m| ft)$/,'e$1'):f;};
      const lbl = `Each ${fmtMm(L/(bracePos.length+1))} bay: ${lenP.map(fmtP).join(' + ')}`;
      parts.push(`<text x="${elevX+elevW-4}" y="${elevY-5}" text-anchor="end" font-size="8.5" fill="${C.dimensionLabel}" font-style="italic" font-family="sans-serif">${esc(lbl)}</text>`);
    }

    const elevUps = [0,...bracePos,L];
    elevUps.forEach(xmm => {
      const x = elevX+xmm*elevScale, isCorner = xmm===0||xmm===L;
      parts.push(`<line x1="${x}" y1="${elevY}" x2="${x}" y2="${groundY}" stroke="${C.upright}" stroke-width="2.5"/>`);
      if(inGnd>0) parts.push(`<line x1="${x}" y1="${groundY}" x2="${x}" y2="${belowGndY}" stroke="${C.upright}" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.6"/>`);
      if(isBuildABall){
        parts.push(_ballMarker(x,elevY));
      } else if(isCorner){
        parts.push(`<circle cx="${x}" cy="${elevY}" r="5.5" fill="${C.joinerCorner}" stroke="#fff" stroke-width="1.2"/>`);
      } else {
        const r=4.5;
        parts.push(`<rect x="${(x-r).toFixed(1)}" y="${(elevY-r).toFixed(1)}" width="${(r*2).toFixed(1)}" height="${(r*2).toFixed(1)}" fill="${C.joinerTee}" stroke="#fff" stroke-width="1.2"/>`);
      }
      if(hasPegs) parts.push(`<polygon points="${x-4},${groundY} ${x+4},${groundY} ${x},${groundY+7}" fill="${C.peg}"/>`);
    });

    if (door && ['front','back'].includes(door.wall||'front')) {
      const dWmm=door.width_mm||750,dPos=door.position||0.5;
      const cx=elevX+L*dPos*elevScale,hw=dWmm/2*elevScale;
      const dHmm=Math.min(H*0.9,2100),dht=dHmm/H*elevH;
      parts.push(`<rect x="${cx-hw}" y="${elevY+elevH-dht}" width="${hw*2}" height="${dht}" fill="#fed7aa" fill-opacity="0.5" stroke="${C.door}" stroke-width="1.5"/>`);
      parts.push(`<line x1="${cx+hw}" y1="${elevY}" x2="${cx+hw}" y2="${groundY}" stroke="${C.upright}" stroke-width="2.5"/>`);
      parts.push(`<circle cx="${cx+hw}" cy="${elevY}" r="5" fill="${C.joinerUpright}" stroke="#fff" stroke-width="1.5"/>`);
      if(hasPegs) parts.push(`<polygon points="${cx+hw-4},${groundY} ${cx+hw+4},${groundY} ${cx+hw},${groundY+7}" fill="${C.peg}"/>`);
    }

    lenJoins.forEach(xmm => {
      const x=elevX+xmm*elevScale;
      parts.push(`<line x1="${x}" y1="${elevY-5}" x2="${x}" y2="${elevY+5}" stroke="#fff" stroke-width="3.5"/>`);
      parts.push(`<line x1="${x}" y1="${elevY-5}" x2="${x}" y2="${elevY+5}" stroke="${C.dimensionLine}" stroke-width="1.8"/>`);
    });

    if (s.corner_braces > 0) {
      const br = Math.min(elevW * 0.1, elevH * 0.35);
      const elevCorners = [
        { cx: elevX,        cy: elevY, dx:  1, dy:  1 },
        { cx: elevX+elevW,  cy: elevY, dx: -1, dy:  1 },
      ];
      elevCorners.forEach(({ cx, cy, dx, dy }) => {
        const x1 = cx + dx * br, y1 = cy;
        const x2 = cx,           y2 = cy + dy * br;
        parts.push(`<path d="M${x1.toFixed(1)},${y1.toFixed(1)} Q${cx.toFixed(1)},${cy.toFixed(1)} ${x2.toFixed(1)},${y2.toFixed(1)}" fill="none" stroke="#dc2626" stroke-width="2.5" stroke-linecap="round"/>`);
        parts.push(`<line x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}" x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3,2" opacity="0.7"/>`);
      });
    }
    if (hasPegs) {
      const pegCount = Math.max(2, Math.ceil(L/PEG_SPACING_MM)+1);
      for(let i=0;i<pegCount;i++){const t=i/(pegCount-1);const px=elevX+t*elevW;parts.push(`<polygon points="${px-3},${groundY+1} ${px+3},${groundY+1} ${px},${groundY+7}" fill="${C.peg}" opacity="0.6"/>`);}
    }

    parts.push(`<text x="${elevX+2}" y="${elevY-8}" font-size="9" fill="${C.dimensionLabel}" font-weight="600" font-family="sans-serif">${esc(poleMm+'mm pole')}</text>`);

    const annX=elevX+elevW+24,midY=(elevY+groundY)/2;
    parts.push(`<line x1="${annX}" y1="${elevY}" x2="${annX}" y2="${groundY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    parts.push(`<line x1="${annX-3}" y1="${elevY}" x2="${annX+3}" y2="${elevY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    parts.push(`<line x1="${annX-3}" y1="${groundY}" x2="${annX+3}" y2="${groundY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    parts.push(`<text x="${annX+6}" y="${midY}" text-anchor="middle" font-size="9" fill="${C.dimensionLabel}" font-family="sans-serif" transform="rotate(90 ${annX+6} ${midY})">Erected height ${esc(fmtMm(H))}</text>`);

    const annX2=elevX-18;
    parts.push(`<line x1="${annX2}" y1="${elevY}" x2="${annX2}" y2="${groundY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    parts.push(`<line x1="${annX2-3}" y1="${elevY}" x2="${annX2+3}" y2="${elevY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    parts.push(`<line x1="${annX2-3}" y1="${groundY}" x2="${annX2+3}" y2="${groundY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
    const midA=(elevY+groundY)/2;
    parts.push(`<text x="${annX2-5}" y="${midA}" text-anchor="middle" font-size="8.5" fill="${C.dimensionLabel}" font-family="sans-serif" transform="rotate(-90 ${annX2-5} ${midA})">${esc(fmtMm(H)+' above')}</text>`);
    if(inGnd>0){
      const midG=(groundY+belowGndY)/2;
      parts.push(`<line x1="${annX2}" y1="${groundY}" x2="${annX2}" y2="${belowGndY}" stroke="${C.dimensionLine}" stroke-width="0.9" stroke-dasharray="3,2"/>`);
      parts.push(`<line x1="${annX2-3}" y1="${belowGndY}" x2="${annX2+3}" y2="${belowGndY}" stroke="${C.dimensionLine}" stroke-width="0.9"/>`);
      parts.push(`<text x="${annX2-5}" y="${midG}" text-anchor="middle" font-size="8" fill="${C.dimensionLabel}" font-family="sans-serif" opacity="0.8" transform="rotate(-90 ${annX2-5} ${midG})">${esc(fmtMm(inGnd)+' in gnd')}</text>`);
    }

    const lblY=belowGndY+(elevUps.length>2?36:20);
    if(elevUps.length>2){
      for(let i=0;i<elevUps.length-1;i++){
        const bx1=elevX+elevUps[i]*elevScale,bx2=elevX+elevUps[i+1]*elevScale;
        parts.push(`<line x1="${bx1}" y1="${belowGndY+3}" x2="${bx1}" y2="${belowGndY+14}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${bx2}" y1="${belowGndY+3}" x2="${bx2}" y2="${belowGndY+14}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<line x1="${bx1}" y1="${belowGndY+10}" x2="${bx2}" y2="${belowGndY+10}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
        parts.push(`<text x="${(bx1+bx2)/2}" y="${belowGndY+22}" text-anchor="middle" font-size="9" fill="${C.dimensionLabel}" font-family="sans-serif">${esc(fmtMm(elevUps[i+1]-elevUps[i]))}</text>`);
      }
    }
    parts.push(`<line x1="${elevX}" y1="${lblY}" x2="${elevX+elevW}" y2="${lblY}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<text x="${elevX+elevW/2}" y="${lblY+12}" text-anchor="middle" font-size="10" fill="${C.dimensionLabel}" font-family="sans-serif">Length ${esc(fmtMm(L))}</text>`);

    parts.push('</svg>');
    return parts.join('\n');
  }

  function buildIsometricSvg(bom) {
    const dims = bom.dimensions_mm;
    const s    = bom.summary;
    const Lmm = dims.length, Wmm = dims.width, Hmm = s.achievable_height_mm;
    const poleMm = s.upright_pole_length_mm || Hmm;
    const inGnd  = poleMm - Hmm;
    const bracePos = s.cross_brace_positions_mm || [];
    const rowPos   = s.internal_row_positions_mm || [];
    const door     = s.door;
    const hasNetting = !!bom.netting;
    const hasPegs = !!bom.pegs;
    const isBuildABall = (bom.joiner_system === 'build_a_ball');

    const FORE = 0.5, ANGLE = Math.PI / 6;
    const cosA = Math.cos(ANGLE), sinA = Math.sin(ANGLE);

    const SVG_W = 880, SVG_H = 420;
    const L_PAD = 60, R_PAD = 80, T_PAD = 30, B_PAD = 60;
    const avW = SVG_W - L_PAD - R_PAD, avH = SVG_H - T_PAD - B_PAD;
    const scX = avW / (Lmm + Wmm*FORE*cosA);
    const scY = avH / (Hmm + Wmm*FORE*sinA);
    const sc  = Math.min(scX, scY);

    function p(x, y, z) {
      return [
        L_PAD + x*sc + z*sc*FORE*cosA,
        (SVG_H - B_PAD) - y*sc - z*sc*FORE*sinA,
      ];
    }

    const allX = [0,...bracePos,Lmm];
    const allZ = [0,...rowPos,Wmm];
    const parts = [`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${SVG_W} ${SVG_H}" style="display:block;min-width:500px;width:100%;height:auto">`];

    function iline(x1,y1,z1,x2,y2,z2,col,lw,dash=''){
      const[ax,ay]=p(x1,y1,z1),[bx,by]=p(x2,y2,z2);
      const da=dash?`stroke-dasharray="${dash}"`:'';
      parts.push(`<line x1="${ax.toFixed(1)}" y1="${ay.toFixed(1)}" x2="${bx.toFixed(1)}" y2="${by.toFixed(1)}" stroke="${col}" stroke-width="${lw}" ${da}/>`);
    }

    function iJoiner(x, y, z, type) {
      const [sx,sy] = p(x,y,z);
      if (isBuildABall) {
        return `<circle cx="${sx.toFixed(1)}" cy="${sy.toFixed(1)}" r="5.5" fill="${C.joinerTee}" stroke="#fff" stroke-width="1.5"/>`;
      }
      if (type === 'corner') {
        return `<circle cx="${sx.toFixed(1)}" cy="${sy.toFixed(1)}" r="5.5" fill="${C.joinerCorner}" stroke="#fff" stroke-width="1.5"/>`;
      }
      if (type === 'tee') {
        const r=4.5;
        return `<rect x="${(sx-r).toFixed(1)}" y="${(sy-r).toFixed(1)}" width="${(r*2).toFixed(1)}" height="${(r*2).toFixed(1)}" fill="${C.joinerTee}" stroke="#fff" stroke-width="1.5"/>`;
      }
      const r=5;
      return `<rect x="${(sx-r).toFixed(1)}" y="${(sy-r).toFixed(1)}" width="${(r*2).toFixed(1)}" height="${(r*2).toFixed(1)}" fill="${C.joinerCross}" stroke="#fff" stroke-width="1.5" transform="rotate(45 ${sx.toFixed(1)} ${sy.toFixed(1)})"/>`;
    }

    const [gx0,gy0]=p(0,0,0),[gx1,gy1]=p(Lmm,0,0),[gx2,gy2]=p(Lmm,0,Wmm),[gx3,gy3]=p(0,0,Wmm);
    parts.push(`<polygon points="${gx0},${gy0} ${gx1},${gy1} ${gx2},${gy2} ${gx3},${gy3}" fill="#f3f4f6" stroke="${C.ground}" stroke-width="0.5"/>`);

    if (hasNetting) {
      function nettingPanel(c0,c1,c2,c3){
        const pts=[c0,c1,c2,c3].map(([x,y,z])=>p(x,y,z).map(v=>v.toFixed(1)).join(',')).join(' ');
        parts.push(`<polygon points="${pts}" fill="${C.netting}" stroke="${C.nettingStroke}" stroke-width="1" stroke-dasharray="3,2"/>`);
      }
      nettingPanel([0,Hmm,0],[Lmm,Hmm,0],[Lmm,Hmm,Wmm],[0,Hmm,Wmm]);
      nettingPanel([0,0,0],[Lmm,0,0],[Lmm,Hmm,0],[0,Hmm,0]);
      nettingPanel([Lmm,0,0],[Lmm,0,Wmm],[Lmm,Hmm,Wmm],[Lmm,Hmm,0]);
    }

    for(let i=0;i<allX.length-1;i++) iline(allX[i],Hmm,Wmm,allX[i+1],Hmm,Wmm,C.lengthBar,1.5);
    for(let j=0;j<allZ.length-1;j++) iline(Lmm,Hmm,allZ[j],Lmm,Hmm,allZ[j+1],C.widthBar,1.5);
    [0,Lmm].forEach(x=>{iline(x,0,Wmm,x,Hmm,Wmm,C.upright,1.8);if(inGnd>0)iline(x,0,Wmm,x,-inGnd*0.3,Wmm,C.upright,1,'3,2');});
    bracePos.forEach(x=>{iline(x,0,Wmm,x,Hmm,Wmm,C.upright,1.5);if(inGnd>0)iline(x,0,Wmm,x,-inGnd*0.3,Wmm,C.upright,1,'3,2');});
    rowPos.forEach(z=>{iline(Lmm,0,z,Lmm,Hmm,z,C.upright,1.5);});
    rowPos.forEach(z=>{for(let i=0;i<allX.length-1;i++)iline(allX[i],Hmm,z,allX[i+1],Hmm,z,C.lengthBar,1.2);});
    bracePos.forEach(x=>{for(let j=0;j<allZ.length-1;j++)iline(x,Hmm,allZ[j],x,Hmm,allZ[j+1],C.widthBar,1.2);allZ.forEach(z=>iline(x,0,z,x,Hmm,z,C.upright,1.5));});

    if (door) {
      const dWmm=door.width_mm||750,dPos=door.position||0.5,dHmm=Math.min(Hmm*0.9,2100),wall=door.wall||'front';
      let pts_d,latchX,latchZ;
      if(['front','back'].includes(wall)){
        const dz=wall==='front'?0:Wmm,cx=Lmm*dPos,x1=cx-dWmm/2,x2=cx+dWmm/2;
        pts_d=[p(x1,0,dz),p(x2,0,dz),p(x2,dHmm,dz),p(x1,dHmm,dz)];
        latchX=x2;latchZ=dz;
      } else {
        const dx=wall==='left'?0:Lmm,cz=Wmm*dPos,z1=cz-dWmm/2,z2=cz+dWmm/2;
        pts_d=[p(dx,0,z1),p(dx,0,z2),p(dx,dHmm,z2),p(dx,dHmm,z1)];
        latchX=dx;latchZ=z2;
      }
      parts.push(`<polygon points="${pts_d.map(([x,y])=>`${x.toFixed(1)},${y.toFixed(1)}`).join(' ')}" fill="#fed7aa" fill-opacity="0.7" stroke="${C.door}" stroke-width="1.5"/>`);
      iline(latchX,0,latchZ,latchX,Hmm,latchZ,C.upright,2);
    }

    for(let j=0;j<allZ.length-1;j++) iline(0,Hmm,allZ[j],0,Hmm,allZ[j+1],C.widthBar,2);
    for(let i=0;i<allX.length-1;i++) iline(allX[i],Hmm,0,allX[i+1],Hmm,0,C.lengthBar,2.5);
    [0,Lmm].forEach(x=>{iline(x,0,0,x,Hmm,0,C.upright,2.5);if(inGnd>0)iline(x,0,0,x,-inGnd*0.3,0,C.upright,1.2,'3,2');});
    bracePos.forEach(x=>{iline(x,0,0,x,Hmm,0,C.upright,1.5);if(inGnd>0)iline(x,0,0,x,-inGnd*0.3,0,C.upright,1,'3,2');});
    allZ.filter(z=>z!==0&&z!==Wmm).forEach(z=>iline(0,0,z,0,Hmm,z,C.upright,1.5));

    allX.forEach((x,i) => allZ.forEach((z,j) => {
      const edX = i===0||i===allX.length-1, edZ = j===0||j===allZ.length-1;
      const type = (edX&&edZ)?'corner':(edX||edZ)?'tee':'cross';
      parts.push(iJoiner(x,Hmm,z,type));
    }));

    if (door) {
      const dWmm=door.width_mm||750,dPos=door.position||0.5,wall=door.wall||'front';
      let lx,lz;
      if(['front','back'].includes(wall)){lx=Lmm*dPos+dWmm/2;lz=wall==='front'?0:Wmm;}
      else{lx=wall==='left'?0:Lmm;lz=Wmm*dPos+dWmm/2;}
      const[sx,sy]=p(lx,Hmm,lz);
      parts.push(`<circle cx="${sx.toFixed(1)}" cy="${sy.toFixed(1)}" r="5.5" fill="${C.joinerUpright}" stroke="#fff" stroke-width="1.5"/>`);
    }

    if (hasPegs) {
      const PEG_SP = 500;
      function pegCount(totalMm){return Math.max(2,Math.ceil(totalMm/PEG_SP)+1);}
      const ps=5;
      function isoPeg(xmm,zmm){const[sx,sy]=p(xmm,0,zmm);return`<polygon points="${(sx-ps*0.7).toFixed(1)},${(sy-ps*0.5).toFixed(1)} ${(sx+ps*0.7).toFixed(1)},${(sy-ps*0.5).toFixed(1)} ${sx.toFixed(1)},${(sy+ps).toFixed(1)}" fill="${C.peg}" stroke="#fff" stroke-width="0.8"/>`;}
      const nL=pegCount(Lmm),nW=pegCount(Wmm);
      for(let i=0;i<nL;i++){const xmm=i/(nL-1)*Lmm;parts.push(isoPeg(xmm,0));parts.push(isoPeg(xmm,Wmm));}
      for(let j=0;j<nW;j++){const zmm=j/(nW-1)*Wmm;if(zmm>0&&zmm<Wmm){parts.push(isoPeg(0,zmm));parts.push(isoPeg(Lmm,zmm));}}
    }

    const[sx0,sy0]=p(0,0,0),[sx1,sy1]=p(Lmm,0,0),[sx2,sy2]=p(Lmm,0,Wmm),[stx,sty]=p(0,Hmm,0);
    const ly=Math.max(sy0,sy1)+18;
    parts.push(`<line x1="${sx0}" y1="${sy0}" x2="${sx0}" y2="${ly-2}" stroke="${C.dimensionLine}" stroke-width="0.6"/>`);
    parts.push(`<line x1="${sx1}" y1="${sy1}" x2="${sx1}" y2="${ly-2}" stroke="${C.dimensionLine}" stroke-width="0.6"/>`);
    parts.push(`<line x1="${sx0}" y1="${ly}" x2="${sx1}" y2="${ly}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<text x="${(sx0+sx1)/2}" y="${ly+11}" text-anchor="middle" font-size="11" fill="${C.dimensionLabel}" font-family="sans-serif">Length ${esc(fmtMm(Lmm))}</text>`);
    parts.push(`<text x="${(sx1+sx2)/2+8}" y="${(sy1+sy2)/2}" font-size="10" fill="${C.dimensionLabel}" font-family="sans-serif">Width ${esc(fmtMm(Wmm))}</text>`);
    const lhx=sx0-22,mhy=(sy0+sty)/2;
    parts.push(`<line x1="${lhx}" y1="${sy0}" x2="${lhx}" y2="${sty}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<line x1="${lhx-3}" y1="${sy0}" x2="${lhx+3}" y2="${sy0}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<line x1="${lhx-3}" y1="${sty}" x2="${lhx+3}" y2="${sty}" stroke="${C.dimensionLine}" stroke-width="0.8"/>`);
    parts.push(`<text x="${lhx-6}" y="${mhy}" text-anchor="middle" font-size="10" fill="${C.dimensionLabel}" font-family="sans-serif" transform="rotate(-90 ${lhx-6} ${mhy})">Erected height ${esc(fmtMm(Hmm))}</text>`);

    parts.push('</svg>');
    return parts.join('\n');
  }

  function buildLegendSvg(bom) {
    const s = bom.summary;
    const isBuildABall = (bom.joiner_system === 'build_a_ball');
    const hasNetting = !!bom.netting;
    const hasPegs = !!bom.pegs;
    const hasDoor = !!(s.door);

    const items = [
      { type:'line', color: C.upright,   label: 'Upright pole' },
      { type:'line', color: C.lengthBar, label: 'Length pole' },
      { type:'line', color: C.widthBar,  label: 'Width pole' },
    ];

    if (isBuildABall) {
      items.push({ type:'dot', color: C.joinerTee,    label: 'Build-A-Ball joiner' });
    } else {
      items.push({ type:'dot',     color: C.joinerCorner, label: 'Corner joiner' });
      if (s.tee_joiners > 0)   items.push({ type:'square',  color: C.joinerTee,    label: 'Tee joiner (3-way)' });
      if (s.cross_joiners > 0) items.push({ type:'diamond', color: C.joinerCross,  label: 'Cross joiner (4-way)' });
    }
    if (s.corner_braces > 0)
      items.push({ type:'arc', color: '#dc2626', label: 'Corner brace' });
    if (hasDoor) {
      items.push({ type:'line', color: C.door,         label: 'Door opening' });
      items.push({ type:'dot',  color: C.joinerUpright, label: 'Door upright connector' });
    }
    if (hasPegs) items.push({ type:'triangle', color: C.peg, label: 'Peg' });
    if (hasNetting) items.push({ type:'netting',  color: C.nettingStroke, label: 'Netting coverage' });

    const SVG_W = 880;
    const COLS  = Math.min(items.length, 5);
    const ROWS  = Math.ceil(items.length / COLS);
    const COL_W = SVG_W / COLS;
    const ROW_H = 26;
    const PAD   = 10;
    const SVG_H = PAD + ROWS * ROW_H + PAD;
    const SW    = 24;

    const parts = [`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${SVG_W} ${SVG_H}" style="display:block;width:100%;height:auto">`];
    parts.push(`<rect width="${SVG_W}" height="${SVG_H}" fill="#f8f9fa" rx="4" stroke="#e2e8f0" stroke-width="0.8"/>`);

    items.forEach((item, idx) => {
      const col = idx % COLS, row = Math.floor(idx / COLS);
      const x0 = col * COL_W + 6;
      const cy = PAD + row * ROW_H + ROW_H / 2;
      const scx = x0 + SW / 2;
      const textX = x0 + SW + 5;
      const r = SW * 0.22;

      let swatch = '';
      if (item.type === 'line') {
        swatch = `<line x1="${scx - SW/2}" y1="${cy}" x2="${scx + SW/2}" y2="${cy}" stroke="${item.color}" stroke-width="2.5" stroke-linecap="round"/>`;
      } else if (item.type === 'dot') {
        swatch = `<circle cx="${scx}" cy="${cy}" r="${r}" fill="${item.color}" stroke="#fff" stroke-width="1.2"/>`;
      } else if (item.type === 'square') {
        swatch = `<rect x="${scx-r}" y="${cy-r}" width="${r*2}" height="${r*2}" fill="${item.color}" stroke="#fff" stroke-width="1.2"/>`;
      } else if (item.type === 'diamond') {
        swatch = `<rect x="${scx-r}" y="${cy-r}" width="${r*2}" height="${r*2}" fill="${item.color}" stroke="#fff" stroke-width="1.2" transform="rotate(45 ${scx} ${cy})"/>`;
      } else if (item.type === 'arc') {
        const r2 = SW * 0.38;
        swatch = `<path d="M${scx-r2},${cy} Q${scx-r2},${cy-r2} ${scx},${cy-r2}" fill="none" stroke="${item.color}" stroke-width="2.5" stroke-linecap="round"/>`
               + `<line x1="${scx-r2}" y1="${cy}" x2="${scx}" y2="${cy-r2}" stroke="${item.color}" stroke-width="1.2" stroke-dasharray="2,1.5" opacity="0.8"/>`;
      } else if (item.type === 'triangle') {
        swatch = `<polygon points="${scx},${cy-r} ${scx+r},${cy+r*0.7} ${scx-r},${cy+r*0.7}" fill="${item.color}"/>`;
      } else if (item.type === 'netting') {
        swatch = `<rect x="${scx-SW/2}" y="${cy-r}" width="${SW}" height="${r*2}" fill="${C.netting}" stroke="${item.color}" stroke-width="1.2" stroke-dasharray="3,2"/>`;
      }
      parts.push(swatch);
      parts.push(`<text x="${textX}" y="${cy+4}" font-size="10" fill="#374151" font-family="sans-serif">${esc(item.label)}</text>`);
    });

    parts.push('</svg>');
    return parts.join('\n');
  }

  const ROOT_SEL = '#gn-cage-calculator';
  let currentBom = null;

  function $(sel,root){return(root||document).querySelector(sel);}
  function $$(sel,root){return[...(root||document).querySelectorAll(sel)];}
  function $id(id){return document.getElementById(id);}

  function h(tag,attrs,...children){
    const el=document.createElement(tag);
    for(const[k,v]of Object.entries(attrs||{})){if(k==='class')el.className=v;else if(k.startsWith('on'))el.addEventListener(k.slice(2),v);else el.setAttribute(k,v);}
    for(const child of children){if(typeof child==='string')el.appendChild(document.createTextNode(child));else if(child)el.appendChild(child);}
    return el;
  }
  function sel(options,attrs){const s=h('select',attrs);for(const o of options){const opt=h('option',{value:o.value},o.label);s.appendChild(opt);}return s;}
  function field(labelText,unit,inputEl,helpEl){const lbl=h('label',{},labelText,unit?h('span',{class:'gncc-unit'},unit):null);const wrap=h('div',{class:'gncc-field'},lbl,inputEl);if(helpEl)wrap.appendChild(helpEl);return wrap;}

  let formEls;

  function buildForm(root) {
    const getCageFeatures=()=>CAGE_TYPES.find(c=>c.id===cageTypeEl.value)?.features||{};
    const cageTypeEl=sel(CAGE_TYPES.map(c=>({value:c.id,label:c.display_name})),{id:'gncc-cage-type',class:'gncc-cage-type'});
    const cageDesc=h('p',{class:'gncc-help',id:'gncc-cage-desc'});
    const unitsEl=sel([{value:'m',label:'Metres (m)'},{value:'ft',label:'Feet (ft)'}],{id:'gncc-units'});
    const heightEl=h('input',{type:'number',id:'gncc-height',value:'0.7',step:'0.01',min:'0'});
    const heightUnit=h('span',{class:'gncc-unit',id:'gncc-height-unit'},'metres');
    const heightHelp=h('div',{class:'gncc-help',id:'gncc-height-help'});
    const heightLbl=h('label',{for:'gncc-height'},'Erected height ',heightUnit);
    const heightField=h('div',{class:'gncc-field'},heightLbl,heightEl,heightHelp);
    const widthEl=h('input',{type:'number',id:'gncc-width',value:'1.8',step:'0.01',min:'0.1'});
    const lengthEl=h('input',{type:'number',id:'gncc-length',value:'3',step:'0.01',min:'0.1'});

    let fixedHeightSpan=null;
    function installFixedHeight(mm){if(!fixedHeightSpan){fixedHeightSpan=h('span',{class:'gncc-field','data-fixed-mm':mm,style:'display:inline-block;padding:8px 11px;background:#f3f4f6;border:1px solid #d1d5db;border-radius:8px;font-size:14px;color:#374151;'});heightEl.parentNode.insertBefore(fixedHeightSpan,heightEl);heightEl.style.display='none';heightUnit.style.display='none';}fixedHeightSpan.setAttribute('data-fixed-mm',mm);fixedHeightSpan.textContent=`${mm/1000} m`;}
    function removeFixedHeight(){if(fixedHeightSpan){fixedHeightSpan.remove();fixedHeightSpan=null;}heightEl.style.display='';heightUnit.style.display='';}

    let heightSelectEl=null;
    function installHeightSelect(poleToHeight){const opts=Object.entries(poleToHeight).map(([p,hh])=>({value:hh,label:`${hh/1000} m above ground (${p}mm pole, ${p-hh}mm in ground)`})).sort((a,b)=>a.value-b.value);if(!opts.length)return;if(heightSelectEl){heightSelectEl.innerHTML='';opts.forEach(o=>{const op=h('option',{value:o.value},o.label);heightSelectEl.appendChild(op);});return;}heightSelectEl=sel(opts,{id:'gncc-height-select'});heightSelectEl.value=opts[opts.length-1].value;heightEl.parentNode.insertBefore(heightSelectEl,heightEl);heightEl.style.display='none';heightUnit.style.display='none';heightSelectEl.addEventListener('change',updateHeightHelp);}
    function removeHeightSelect(){if(heightSelectEl){heightSelectEl.remove();heightSelectEl=null;}heightEl.style.display='';heightUnit.style.display='';}

    function getHeightMm(){if(fixedHeightSpan)return Number(fixedHeightSpan.getAttribute('data-fixed-mm'));if(heightSelectEl)return Number(heightSelectEl.value);const v=parseFloat(heightEl.value)||0;return unitsEl.value==='m'?Math.round(v*1000):Math.round(v*304.8);}
    function toMm(v){return unitsEl.value==='m'?Math.round(parseFloat(v)*1000):Math.round(parseFloat(v)*304.8);}

    function updateHeightHelp(){const features=getCageFeatures();if(features.fixed_height_mm){heightHelp.textContent='';return;}const mm=getHeightMm();try{if(cageTypeEl.value==='walk_in'){const{pole,achieved}=walkinHeightToPole(mm);heightHelp.textContent=`Uses a ${pole}mm pole (${pole-achieved}mm in ground)`;}else if(cageTypeEl.value==='low_19mm'){if(heightSelectEl){const pte=Object.entries(LOW_19MM_POLE_TO_HEIGHT_MM).find(([,hh])=>hh===Number(heightSelectEl.value));if(pte)heightHelp.textContent=`Uses a ${pte[0]}mm pole (${pte[0]-pte[1]}mm in ground)`;}}else{const{pole,achieved}=lowFvHeightToPole(mm);heightHelp.textContent=`Uses a ${pole}mm pole (${pole-achieved}mm in ground)`;}}catch{heightHelp.textContent='';}}

    const joinerEl=sel(JOINER_SYSTEMS,{id:'gncc-joiner'});
    const joinerSection=h('div',{class:'gncc-section',id:'gncc-joiner-section'},h('h3',{class:'gncc-section-title'},'Joiner system'),field('Joiner system','',joinerEl));
    const pegEl=sel(PEG_TYPES,{id:'gncc-peg'});pegEl.value='galvanised_steel';
    const nettingEl=sel(NETTING_OPTIONS,{id:'gncc-netting'});
    const nettingHint=h('div',{class:'gncc-help',id:'gncc-netting-hint'});
    const DOOR_COUNT_OPTIONS=[{value:'0',label:'No Door'},{value:'1',label:'1 Door'},{value:'2',label:'2 Doors'},{value:'3',label:'3 Doors'},{value:'4',label:'4 Doors'}];
    const doorCountEl=sel(DOOR_COUNT_OPTIONS,{id:'gncc-door-count'});
    const doorNote=h('p',{class:'gncc-help'},'Door shown for illustration purposes only. The door can be positioned anywhere on the cage, but the right-hand side (when stood outside) must be next to an upright to enable the door catch to be fitted. Diagram shows a maximum of one door.');

    function toggleBtn(id, labelText, defaultChecked) {
      const btn = h('button', {
        type: 'button', id,
        class: 'gncc-toggle-btn' + (defaultChecked ? ' active' : ''),
        'aria-pressed': defaultChecked ? 'true' : 'false',
      }, (defaultChecked ? '✓ ' : '') + labelText);
      const chk = h('input', { type: 'hidden', id: id + '-val', value: defaultChecked ? '1' : '0' });
      btn.addEventListener('click', () => {
        const isActive = btn.classList.toggle('active');
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.textContent = (isActive ? '✓ ' : '') + labelText;
        chk.value = isActive ? '1' : '0';
      });
      btn.isChecked = () => btn.classList.contains('active');
      return { btn, chk };
    }

    const CORNER_BRACES_OPTIONS=[{value:'0',label:'No Corner braces Kit'},{value:'1',label:'Corner braces kit'}];
    const bracesEl=sel(CORNER_BRACES_OPTIONS,{id:'gncc-corner-braces'});bracesEl.value='0';
    const { btn: allenKeyBtnEl, chk: allenKeyChkEl } = toggleBtn('gncc-allen-key', 'Include allen key (recommended)', true);

    const bracesRowEl  = field('Corner braces','',bracesEl);
    const allenKeyRowEl = h('div', { class: 'gncc-field', style: 'display:none' }, allenKeyBtnEl, allenKeyChkEl);

    const doorSection=h('div',{class:'gncc-section',id:'gncc-door-section'},
      h('h3',{class:'gncc-section-title'},'Door'),
      field('Door','',doorCountEl),
      doorNote);

    const extrasSection=h('div',{class:'gncc-section',id:'gncc-extras-section'},
      h('h3',{class:'gncc-section-title'},'Structural Extras'),
      bracesRowEl,
      allenKeyRowEl);

    function applyCageTypeFeatures(){
      const features=getCageFeatures();
      const isPremium = cageTypeEl.value === 'premium_walk_in';
      cageDesc.textContent=CAGE_TYPES.find(c=>c.id===cageTypeEl.value)?.description||'';
      removeFixedHeight();removeHeightSelect();
      if(features.fixed_height_mm)installFixedHeight(features.fixed_height_mm);
      else if(features.pole_to_height)installHeightSelect(features.pole_to_height);
      joinerSection.style.display=features.joiner_system?'':'none';
      doorSection.style.display=features.door?'':'none';
      extrasSection.style.display=features.extras?'':'none';
      bracesRowEl.style.display  = (features.extras && !isPremium) ? '' : 'none';
      allenKeyRowEl.style.display = (features.extras && isPremium)  ? '' : 'none';
      const allowed=features.netting_types||[];
      const pairsWithPoultry = cageTypeEl.value==='walk_in' || cageTypeEl.value==='premium_walk_in';
      Array.from(nettingEl.options).forEach(opt=>{
        opt.hidden=opt.value!=='none'&&!allowed.includes(opt.value);
        if(opt.value==='anti_bird_black')opt.textContent=pairsWithPoultry?'Black Bird Netting (Roof) & Fruit Cage (Side)':'Anti-Bird Netting (Black)';
      });
      if(nettingEl.value!=='none'&&!allowed.includes(nettingEl.value))nettingEl.value='none';
      updateHeightHelp();
    }

    cageTypeEl.addEventListener('change',applyCageTypeFeatures);
    unitsEl.addEventListener('change',()=>{const unitLabel=unitsEl.value==='ft'?'feet':'metres';heightUnit.textContent=unitLabel;$id('gncc-width-unit').textContent=unitLabel;$id('gncc-length-unit').textContent=unitLabel;});
    heightEl.addEventListener('input',updateHeightHelp);
    nettingEl.addEventListener('change',()=>{nettingHint.textContent='';});

    const calcBtn=h('button',{class:'gncc-btn gncc-btn-primary',type:'button'},'Calculate');
    const resetBtn=h('button',{class:'gncc-btn gncc-btn-secondary',type:'button'},'Reset');
    calcBtn.addEventListener('click',onCalculate);
    resetBtn.addEventListener('click',onReset);

    const form=h('div',{class:'gncc-form-panel'},
      h('div',{class:'gncc-section'},h('h3',{class:'gncc-section-title'},'Cage type'),field('Select cage','',cageTypeEl),cageDesc),
      h('div',{class:'gncc-section'},h('h3',{class:'gncc-section-title'},'Units'),field('Units','',unitsEl)),
      h('div',{class:'gncc-section'},h('h3',{class:'gncc-section-title'},'Dimensions'),h('div',{class:'gncc-dims-grid'},heightField,field('Width',h('span',{class:'gncc-unit',id:'gncc-width-unit'},'metres'),widthEl),field('Length',h('span',{class:'gncc-unit',id:'gncc-length-unit'},'metres'),lengthEl))),
      h('div',{class:'gncc-section'},h('h3',{class:'gncc-section-title'},'Components'),joinerSection,field('Peg type','',pegEl),field('Netting','',nettingEl,nettingHint)),
      doorSection,extrasSection,
      h('div',{class:'gncc-btn-row'},resetBtn,calcBtn));

    applyCageTypeFeatures();
    return{form,calcBtn,els:{cageTypeEl,unitsEl,heightEl,widthEl,lengthEl,joinerEl,pegEl,nettingEl,doorCountEl,bracesEl,allenKeyBtnEl,getHeightMm,toMm}};
  }

  function buildConnectorTableSvg(bom) {
    const isBuildABall = (bom.joiner_system === 'build_a_ball');
    const hasDoor = !!(bom.summary && bom.summary.door);
    const s = bom.summary || {};

    const connectors = [];
    if (isBuildABall) {
      connectors.push({ type: 'ball',   color: C.joinerTee,    label: 'Build-A-Ball',       sub: 'All junction positions' });
    } else {
      connectors.push({ type: 'corner', color: C.joinerCorner, label: 'Corner joiner',      sub: 'Corner positions' });
      if (s.tee_joiners > 0)
        connectors.push({ type: 'tee',  color: C.joinerTee,    label: 'Tee joiner (3-way)', sub: 'Edge midpoints' });
      if (s.cross_joiners > 0)
        connectors.push({ type: 'cross',color: C.joinerCross,  label: 'Cross joiner (4-way)', sub: 'Interior junctions' });
    }
    if (hasDoor)
      connectors.push({ type: 'door', color: '#111111', label: 'Door upright\nconnector', sub: 'Door latch pole' });

    if (!connectors.length) return '';

    const SVG_W = 880;
    const COLS  = connectors.length;
    const COL_W = SVG_W / COLS;
    const ILL_H = 110;
    const LBL_H = 42;
    const PAD   = 14;
    const SVG_H = PAD + ILL_H + LBL_H + PAD;

    const parts = [];
    parts.push(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${SVG_W} ${SVG_H}" style="display:block;width:100%;height:auto">`);
    parts.push(`<rect width="${SVG_W}" height="${SVG_H}" fill="#ffffff" rx="4" stroke="#e2e8f0" stroke-width="0.8"/>`);
    parts.push(`<text x="${SVG_W/2}" y="${PAD-2}" text-anchor="middle" font-size="9" fill="#6b7280" font-family="sans-serif" font-style="italic">Connector types used in this cage</text>`);

    connectors.forEach((conn, i) => {
      const cx  = COL_W * i + COL_W / 2;
      const icy = PAD + ILL_H / 2 + 4;
      const col = conn.color;
      const tubeW = 10, tubeLen = 32, bodyR = 16;

      if (i > 0)
        parts.push(`<line x1="${COL_W*i}" y1="${PAD}" x2="${COL_W*i}" y2="${SVG_H-PAD}" stroke="#e2e8f0" stroke-width="0.8"/>`);

      function tubeArm(dx, dy, len) {
        const sx = cx + dx*bodyR, sy = icy + dy*bodyR;
        const ex = cx + dx*(bodyR+len), ey = icy + dy*(bodyR+len);
        const px = -dy*tubeW, py = dx*tubeW;
        const pts = [[sx+px,sy+py],[sx-px,sy-py],[ex-px,ey-py],[ex+px,ey+py]].map(([x,y])=>`${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
        parts.push(`<polygon points="${pts}" fill="${col}" opacity="0.85"/>`);
        parts.push(`<ellipse cx="${ex.toFixed(1)}" cy="${ey.toFixed(1)}" rx="${tubeW}" ry="${(tubeW*0.4).toFixed(1)}" fill="#222" opacity="0.5" transform="rotate(${Math.atan2(dy,dx)*180/Math.PI} ${ex.toFixed(1)} ${ey.toFixed(1)})"/>`);
        const hlPts = [[sx+px*0.5,sy+py*0.5],[sx+px*0.8,sy+py*0.8],[ex+px*0.8,ey+py*0.8],[ex+px*0.5,ey+py*0.5]].map(([x,y])=>`${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
        parts.push(`<polygon points="${hlPts}" fill="white" opacity="0.25"/>`);
      }

      if (conn.type === 'ball') {
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR+4}" fill="${col}" opacity="0.15"/>`);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="${col}"/>`);
        parts.push(`<defs><radialGradient id="sg${i}" cx="35%" cy="30%" r="65%"><stop offset="0%" stop-color="white" stop-opacity="0.4"/><stop offset="100%" stop-color="black" stop-opacity="0.25"/></radialGradient></defs>`);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="url(#sg${i})"/>`);
        [0,72,144,216,288].forEach(deg => {
          const rad = deg*Math.PI/180;
          parts.push(`<circle cx="${(cx+Math.cos(rad)*(bodyR-3)).toFixed(1)}" cy="${(icy+Math.sin(rad)*(bodyR-3)).toFixed(1)}" r="4" fill="#222" opacity="0.5"/>`);
        });
      } else if (conn.type === 'door') {
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR+2}" fill="#333" opacity="0.12"/>`);
        parts.push(`<defs><radialGradient id="dg${i}" cx="35%" cy="30%" r="65%"><stop offset="0%" stop-color="white" stop-opacity="0.3"/><stop offset="100%" stop-color="black" stop-opacity="0.2"/></radialGradient></defs>`);
        tubeArm(0, -1, tubeLen*0.7);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="#111"/>`);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="url(#dg${i})"/>`);
      } else {
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR+3}" fill="rgba(0,0,0,0.18)"/>`);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="${col}"/>`);
        if (conn.type === 'corner')      { tubeArm(1,0,tubeLen); tubeArm(0,1,tubeLen); }
        else if (conn.type === 'tee')    { tubeArm(-1,0,tubeLen); tubeArm(1,0,tubeLen); tubeArm(0,1,tubeLen); }
        else if (conn.type === 'cross')  { tubeArm(-1,0,tubeLen); tubeArm(1,0,tubeLen); tubeArm(0,-1,tubeLen); tubeArm(0,1,tubeLen); }
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="${col}"/>`);
        parts.push(`<circle cx="${(cx-bodyR*0.3).toFixed(1)}" cy="${(icy-bodyR*0.3).toFixed(1)}" r="${(bodyR*0.45).toFixed(1)}" fill="white" opacity="0.22"/>`);
        parts.push(`<circle cx="${cx}" cy="${icy}" r="${bodyR}" fill="none" stroke="rgba(0,0,0,0.15)" stroke-width="1.5"/>`);
      }

      const labelY = PAD + ILL_H + 8;
      const sw = 7;
      if (conn.type === 'corner')
        parts.push(`<circle cx="${cx}" cy="${labelY+2}" r="${sw}" fill="${conn.color}" stroke="#fff" stroke-width="1.2"/>`);
      else if (conn.type === 'tee')
        parts.push(`<rect x="${cx-sw}" y="${labelY-sw+2}" width="${sw*2}" height="${sw*2}" fill="${conn.color}" stroke="#fff" stroke-width="1.2"/>`);
      else if (conn.type === 'cross')
        parts.push(`<rect x="${cx-sw}" y="${labelY-sw+2}" width="${sw*2}" height="${sw*2}" fill="${conn.color}" stroke="#fff" stroke-width="1.2" transform="rotate(45 ${cx} ${labelY+2})"/>`);
      else
        parts.push(`<circle cx="${cx}" cy="${labelY+2}" r="${sw}" fill="${conn.color}" stroke="#fff" stroke-width="1.2"/>`);

      const lines = conn.label.split('\n');
      lines.forEach((line, li) => {
        parts.push(`<text x="${cx}" y="${labelY+18+li*12}" text-anchor="middle" font-size="9.5" font-weight="600" fill="#1f2937" font-family="sans-serif">${esc(line)}</text>`);
      });
      parts.push(`<text x="${cx}" y="${labelY+18+lines.length*12}" text-anchor="middle" font-size="8.5" fill="#6b7280" font-family="sans-serif">${esc(conn.sub)}</text>`);
    });

    parts.push('</svg>');
    return parts.join('\n');
  }

  const _variantCache = new Map();
  let _priceCurrency = CFG.currency || 'GBP';

  function _formatPrice(minorUnits) {
    const major = minorUnits / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: _priceCurrency }).format(major);
    } catch { return `${_priceCurrency} ${major.toFixed(2)}`; }
  }

  async function _fetchVariant(variantId, forceRefresh = false) {
    if (!forceRefresh && _variantCache.has(variantId)) return _variantCache.get(variantId);
    try {
      const res = await fetch(`/variants/${variantId}.js`, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) { _variantCache.set(variantId, { price: null, available: null, variantId }); return null; }
      const data = await res.json();
      _priceCurrency = data.currency || _priceCurrency;
      const entry = {
        price:     typeof data.price === 'number' ? data.price : null,
        available: typeof data.available === 'boolean' ? data.available : null,
        title:     data.title || '',
        variantId,
        resolvedFromProduct: false,
      };
      _variantCache.set(variantId, entry);
      return entry;
    } catch { _variantCache.set(variantId, { price: null, available: null, variantId }); return null; }
  }

  async function fetchBomPrices(bom) {
    const skuVariantMap = CFG.skuVariantMap || {};
    const skuPriceMap   = CFG.skuPriceMap   || {};

    const allSkus = [];
    const variantIds = new Set();

    function collectItems(items, packAware) {
      if (!items) return;
      for (const item of items) {
        allSkus.push(item.sku);
        const vid = _vid(skuVariantMap[item.sku]);
        if (vid) variantIds.add(vid);
        if (packAware) {
          for (const [sz, ct] of Object.entries(item.packs || {})) {
            if (ct <= 0) continue;
            if (Number(sz) !== 1) {
              const packSku = `${item.sku} — pack of ${sz}`;
              allSkus.push(packSku);
              const pvid = _vid(skuVariantMap[packSku]);
              if (pvid) variantIds.add(pvid);
            } else if (!vid) {
              const resolved = _resolveSkuOrPack(item.sku, skuVariantMap);
              if (resolved && resolved.packSize > 1) {
                allSkus.push(resolved.sku);
                if (resolved.variantId) variantIds.add(resolved.variantId);
              }
            }
          }
        }
      }
    }
    collectItems(bom.pole_packs, true); collectItems(bom.joiners, true); collectItems(bom.clips, true);
    if (bom.pegs) collectItems([bom.pegs], true);
    if (bom.netting)           collectItems([_nettingLineItem(bom.netting, null)]);
    if (bom.netting_secondary) collectItems([_nettingLineItem(bom.netting_secondary, null)]);

    const uncached = [...variantIds].filter(id => !_variantCache.has(id));
    const BATCH = 8;
    for (let i = 0; i < uncached.length; i += BATCH) {
      await Promise.all(uncached.slice(i, i + BATCH).map(id => _fetchVariant(id)));
    }

    const priceMap = new Map();
    const stockMap = new Map();

    function resolveForSku(sku) {
      const configPrice = skuPriceMap[sku];
      const vid = _vid(skuVariantMap[sku]);
      const entry = vid ? _variantCache.get(vid) : null;
      priceMap.set(sku, configPrice !== undefined ? configPrice : (entry?.price ?? null));
      stockMap.set(sku, entry?.available ?? null);
    }

    for (const sku of allSkus) resolveForSku(sku);
    return { priceMap, stockMap };
  }

  function buildHowToUseEmptyState(){
    const steps = [
      ['Choose your cage type', ' — Low Fruit & Veg, Walk-In, Low Cage (19mm) or Premium Walk-In.'],
      ['Pick your units', ' — metres or feet.'],
      ['Enter your dimensions', " — height, width and length. We'll round to the nearest achievable size if needed."],
      ['Choose your components', ' — joiner system, peg type, and netting.'],
      ['Add any extras', ' — door, corner braces, or allen key, where supported.'],
      ['Click Calculate', ' to generate your build.'],
    ];
    const included = [
      ['Diagram', ' — top-down plan and side elevation with dimensions.'],
      ['3D View', ' — isometric view of the assembled cage.'],
      ['Parts list', ' — every part you\'ll need, with live pricing and stock availability.'],
    ];

    const listStyle = 'margin:8px 0 0;padding-left:20px;display:flex;flex-direction:column;gap:6px;text-align:left;font-size:14px';
    const headingStyle = 'margin:0 0 4px;font-size:16px;font-weight:600;color:#111827;text-align:center';

    const ol = h('ol',{style:listStyle});
    steps.forEach(([label,rest])=>{ol.appendChild(h('li',{style:'text-align:left'},h('strong',{},label),rest));});

    const ul = h('ul',{style:listStyle});
    included.forEach(([label,rest])=>{ul.appendChild(h('li',{style:'text-align:left'},h('strong',{},label),rest));});

    const note = h('p',{style:'margin:10px 0 0;font-size:14px;color:#4b5563;text-align:left'},
      'When ready, use ',h('strong',{},'Add to cart'),' to add everything at once, or ',
      h('strong',{},'Download Instructions'),' to save the diagrams and assembly guide as an image.');

    return h('div',{class:'gncc-results-empty'},
      h('h3',{style:headingStyle},'How to use'),
      ol,
      h('h3',{style:headingStyle+';margin-top:16px'},"What's Included"),
      ul,
      note);
  }

  function buildResultsPanel(){
    const panel=h('div',{class:'gncc-results-panel'});
    panel.appendChild(buildHowToUseEmptyState());
    return panel;
  }

  function renderResults(panel, bom) {
    const s=bom.summary,cageType=bom.cage_type,is19mm=cageType==='walk_in'||cageType==='low_19mm',isPremium=cageType==='premium_walk_in';
    panel.innerHTML='';

    if(bom.notices?.length){const nb=h('div',{class:'gncc-notices'});bom.notices.forEach(n=>{nb.appendChild(h('p',{style:'margin:0 0 4px'},n));});panel.appendChild(nb);}

    const summary=h('div',{class:'gncc-summary'});
    const chip=(label,val)=>{const c=h('div',{class:'gncc-chip'},label,h('strong',{},String(val)));summary.appendChild(c);};
    chip(is19mm?'Height':'Erected height',fmtMm(s.achievable_height_mm)+` (${s.upright_pole_length_mm}mm pole)`);
    chip('Width',fmtMm(bom.dimensions_mm.width));chip('Length',fmtMm(bom.dimensions_mm.length));
    chip('Uprights',`${s.total_uprights} (${s.corner_uprights} corner + ${s.internal_uprights} internal)`);
    chip(isPremium?'27mm Joiners':is19mm?'19mm Joiners':'13/16mm Joiners',s.total_joiners_required);
    if(s.anchors)chip('Anchors',s.anchors);
    if(s.door)chip('Doors',s.door.count);
    panel.appendChild(summary);

    const tabsRow=h('div',{class:'gncc-tabs-row'});
    const tabs=h('div',{class:'gncc-tabs'});
    const tabDiagram=h('button',{class:'gncc-tab active',type:'button','data-panel':'diagram'},'Diagram');
    const tabIso=h('button',{class:'gncc-tab',type:'button','data-panel':'iso'},'3D View');
    const tabParts=h('button',{class:'gncc-tab',type:'button','data-panel':'parts'},'Parts list');
    const pngBtn=h('button',{type:'button',class:'gncc-toolbar-btn gncc-toolbar-btn-download'},'⬇ Download Instructions');
    const cartTopBtn = Object.keys(CFG.skuVariantMap||{}).length
      ? h('button',{type:'button',class:'gncc-toolbar-btn gncc-toolbar-btn-cart'},'🛒 Add to cart')
      : null;
    tabs.appendChild(tabDiagram);tabs.appendChild(tabIso);tabs.appendChild(tabParts);
    const toolbarActions=h('div',{class:'gncc-toolbar-actions'});
    if(cartTopBtn)toolbarActions.appendChild(cartTopBtn);
    toolbarActions.appendChild(pngBtn);
    tabsRow.appendChild(tabs);tabsRow.appendChild(toolbarActions);
    panel.appendChild(tabsRow);

    const doorNoteText='Door shown for illustration purposes only. The door can be positioned anywhere on the cage, but the right-hand side (when stood outside) must be next to an upright to enable the door catch to be fitted. Diagram shows a maximum of one door.';

    const diagramPanel=h('div',{class:'gncc-panel active',id:'gncc-diagram-panel'});
    const diagWrap=h('div',{class:'gncc-diagram-wrap'});
    const connTable = buildConnectorTableSvg(bom);
    diagWrap.innerHTML=buildDiagramSvg(bom)
      +'<div style="margin-top:6px">'+buildLegendSvg(bom)+'</div>'
      +(connTable?'<div style="margin-top:6px">'+connTable+'</div>':'');
    diagramPanel.appendChild(diagWrap);
    if(s.door)diagramPanel.appendChild(h('p',{class:'gncc-help',style:'font-style:italic;margin-top:8px'},doorNoteText));
    panel.appendChild(diagramPanel);

    const isoPanel=h('div',{class:'gncc-panel',id:'gncc-iso-panel'});
    const isoWrap=h('div',{class:'gncc-diagram-wrap'});
    isoWrap.innerHTML=buildIsometricSvg(bom)
      +'<div style="margin-top:6px">'+buildLegendSvg(bom)+'</div>'
      +(connTable?'<div style="margin-top:6px">'+connTable+'</div>':'');
    isoPanel.appendChild(isoWrap);
    if(s.door)isoPanel.appendChild(h('p',{class:'gncc-help',style:'font-style:italic;margin-top:8px'},doorNoteText));
    panel.appendChild(isoPanel);

    const partsPanel=h('div',{class:'gncc-panel',id:'gncc-parts-panel'});
    panel.appendChild(partsPanel);

    const cartSection=h('div',{id:'gncc-cart-section'});
    panel.appendChild(cartSection);

    const assemblySection = h('div', { id: 'gncc-assembly-section' });
    renderAssemblySection(assemblySection, bom);
    panel.appendChild(assemblySection);

    [tabDiagram,tabIso,tabParts].forEach(tab=>{
      tab.addEventListener('click',()=>{
        $$('.gncc-tab',panel).forEach(t=>t.classList.remove('active'));
        $$('.gncc-panel',panel).forEach(p=>p.classList.remove('active'));
        tab.classList.add('active');
        panel.querySelector(`#gncc-${tab.dataset.panel}-panel`).classList.add('active');
      });
    });

    pngBtn.addEventListener('click',()=>{
      downloadDiagramPng(bom,diagWrap,isoWrap);
    });

    if(cartTopBtn){
      cartTopBtn.addEventListener('click',()=>{
        const realBtn=cartSection.querySelector('.gncc-btn-cart');
        if(realBtn&&!realBtn.disabled)realBtn.click();
        cartSection.scrollIntoView({behavior:'smooth',block:'center'});
      });
    }

    if (Object.keys(CFG.skuVariantMap||{}).length || Object.keys(CFG.skuPriceMap||{}).length) {
      partsPanel.appendChild(h('div',{style:'padding:24px;text-align:center;color:#6b7280;font-size:13px;font-style:italic'},'Loading prices and stock…'));
      fetchBomPrices(bom).then(({ priceMap, stockMap }) => {
        partsPanel.innerHTML='';
        renderPartsTable(partsPanel, bom, priceMap, stockMap);
        const total = calcBomTotal(bom, priceMap, stockMap);
        if (total !== null) {
          const existing = summary.querySelector('.gncc-chip-total');
          if (existing) existing.remove();
          const totalChip = h('div', { class: 'gncc-chip gncc-chip-total',
            style: 'background:#f0fdf4;border-color:#86efac;color:#166534;font-weight:600' },
            'Total ', h('strong', {}, _formatPrice(total)));
          summary.appendChild(totalChip);
        }
        renderCartSection(cartSection, bom, stockMap);
      }).catch(() => {
        partsPanel.innerHTML='';
        renderPartsTable(partsPanel, bom, null);
        renderCartSection(cartSection, bom);
      });
    } else {
      renderPartsTable(partsPanel, bom, null);
      renderCartSection(cartSection, bom);
    }
  }

  function _packLineTotal(item, priceMap) {
    let sum = 0;
    for (const [sz, ct] of Object.entries(item.packs || {})) {
      if (!ct) continue;
      if (Number(sz) === 1) {
        const p = priceMap.get(item.sku);
        if (p !== null && p !== undefined) { sum += p * ct; continue; }
        const resolved = _resolveSkuOrPack(item.sku);
        const pp = resolved && resolved.packSize > 1 ? priceMap.get(resolved.sku) : null;
        if (pp === null || pp === undefined) return null;
        sum += pp * Math.ceil(ct / resolved.packSize);
        continue;
      }
      const packSku = `${item.sku} — pack of ${sz}`;
      const p = priceMap.get(packSku);
      if (p === null || p === undefined) return null;
      sum += p * ct;
    }
    return sum;
  }

  function calcBomTotal(bom, priceMap, stockMap) {
    if (!priceMap) return null;
    let total = 0, hasAny = false;
    function addItems(items, packAware) {
      if (!items) return;
      for (const item of items) {
        if (stockMap && stockMap.get(item.sku) === false) continue;
        if (packAware) {
          const pt = _packLineTotal(item, priceMap);
          if (pt !== null) { total += pt; hasAny = true; continue; }
        }
        const price = priceMap.get(item.sku);
        if (price !== null && price !== undefined) {
          total += price * item.total_supplied;
          hasAny = true;
        }
      }
    }
    addItems(bom.pole_packs, true); addItems(bom.joiners, true); addItems(bom.clips, true);
    if (bom.pegs) addItems([bom.pegs], true);
    if (bom.netting) addItems([_nettingLineItem(bom.netting, null)]);
    if (bom.netting_secondary) addItems([_nettingLineItem(bom.netting_secondary, null)]);
    return hasAny ? total : null;
  }

  function _nettingLineItem(n, priceMap) {
    const map = CFG.skuVariantMap || {};
    const primary = `${n.display_name} — ${mmToM(n.chosen_width_mm)} × ${n.chosen_length_m}m`;
    if (map[primary] !== undefined) {
      return { sku: primary, required_qty: 1, total_supplied: 1, packs: { 1: 1 } };
    }
    const tW = n.chosen_length_m * 1000, tL = n.chosen_width_mm / 1000;
    if (Number.isInteger(tW) && Number.isInteger(tL)) {
      const transposed = `${n.display_name} — ${mmToM(tW)} × ${tL}m`;
      if (map[transposed] !== undefined) {
        return { sku: transposed, required_qty: 1, total_supplied: 1, packs: { 1: 1 } };
      }
    }
    const perMetre = `${n.display_name} — ${mmToM(n.chosen_width_mm)} per metre`;
    if (map[perMetre] !== undefined) {
      const qty = n.chosen_length_m;
      return { sku: perMetre, required_qty: qty, total_supplied: qty, packs: { 1: qty } };
    }
    if (Number.isInteger(tW)) {
      const perMetreT = `${n.display_name} — ${mmToM(tW)} per metre`;
      if (map[perMetreT] !== undefined) {
        const qty = tL;
        return { sku: perMetreT, required_qty: qty, total_supplied: qty, packs: { 1: qty } };
      }
    }
    return { sku: primary, required_qty: 1, total_supplied: 1, packs: { 1: 1 } };
  }

  function renderPartsTable(panel, bom, priceMap, stockMap) {
    const hasPrices = priceMap && [...priceMap.values()].some(p => p !== null);
    const hasStock  = stockMap && stockMap.size > 0;
    let grandTotal = 0;

    function tableSection(title, items, packAware) {
      if (!items?.length) return;
      const sec = h('div', { class: 'gncc-parts-section' });
      sec.appendChild(h('h4', { class: 'gncc-parts-title' }, title));
      const tbl = h('table', { class: 'gncc-table' });
      let headerCols = '<th>SKU</th>';
      if (hasStock)  headerCols += '<th class="num">Stock</th>';
      headerCols += `<th class="num">Qty</th><th class="num">Packs</th>`;
      if (hasPrices) headerCols += '<th class="num">Unit price</th><th class="num">Total</th>';
      tbl.innerHTML = `<thead><tr>${headerCols}</tr></thead>`;
      const tbody = h('tbody');

      for (const item of items) {
        const packs = Object.entries(item.packs || {}).map(([sz, ct]) => `${ct}× pack of ${sz}`).join(', ');
        const packsFullyMapped = !packAware || (priceMap && _packLineTotal(item, priceMap) !== null);
        let inStock = null;
        if (stockMap && packsFullyMapped) {
          const packEntries = Object.entries(item.packs || {}).filter(([, ct]) => ct > 0);
          if (!packEntries.length) {
            inStock = stockMap.get(item.sku) ?? null;
          } else {
            const states = packEntries
              .map(([sz]) => {
                let packSku = Number(sz) === 1 ? item.sku : `${item.sku} — pack of ${sz}`;
                let v = stockMap.get(packSku);
                if ((v === undefined || v === null) && Number(sz) === 1) {
                  const resolved = _resolveSkuOrPack(item.sku);
                  if (resolved && resolved.packSize > 1) v = stockMap.get(resolved.sku);
                }
                return (v !== undefined && v !== null) ? v : (stockMap.get(item.sku) ?? undefined);
              })
              .filter(s => s !== undefined && s !== null);
            if (!states.length)                     inStock = null;
            else if (states.some(s => s === false)) inStock = false;
            else if (states.every(s => s === true)) inStock = true;
            else                                    inStock = null;
          }
        }
        const isOos   = inStock === false;
        const tr = h('tr');
        if (isOos) tr.style.background = '#fff7f7';

        const skuTd = h('td', {}, item.sku);
        if (isOos) skuTd.appendChild(h('span', {style:'display:inline-block;margin-left:4px;padding:1px 6px;background:#fee2e2;color:#b91c1c;border-radius:4px;font-size:10px;font-weight:600;vertical-align:middle'}, 'Out of stock'));
        tr.appendChild(skuTd);

        if (hasStock) {
          let stockText = '—', stockStyle = 'color:#9ca3af;font-size:11px';
          if (!packsFullyMapped) { /* defaults above */ }
          else if (inStock === true) { stockText = '✓ In stock'; stockStyle = 'color:#16a34a;font-size:11px;font-weight:600'; }
          else if (isOos)            { stockText = '✗ Out of stock'; stockStyle = 'color:#b91c1c;font-size:11px;font-weight:600'; }
          tr.appendChild(h('td', {class:'num', style:stockStyle}, stockText));
        }

        tr.appendChild(h('td', {class:'num'}, String(item.total_supplied)));
        tr.appendChild(h('td', {class:'num', style:'color:#6b7280;font-size:11px'}, packs));

        if (hasPrices) {
          let unitPrice = priceMap.get(item.sku);
          let packSizeNote = null;
          if ((unitPrice === null || unitPrice === undefined) && packAware) {
            const resolved = _resolveSkuOrPack(item.sku);
            if (resolved && resolved.packSize > 1) {
              const pp = priceMap.get(resolved.sku);
              if (pp !== null && pp !== undefined) { unitPrice = pp; packSizeNote = resolved.packSize; }
            }
          }
          let lineTotal = null;
          if (!isOos) {
            if (packAware) {
              lineTotal = _packLineTotal(item, priceMap);
            } else if (unitPrice !== null && unitPrice !== undefined) {
              lineTotal = unitPrice * item.total_supplied;
            }
          }
          if (lineTotal !== null) grandTotal += lineTotal;

          const unitTd = h('td', {class:'num'});
          if (unitPrice !== null && unitPrice !== undefined) {
            unitTd.appendChild(document.createTextNode(_formatPrice(unitPrice)));
            if (packSizeNote) unitTd.appendChild(h('span', {style:'color:#9ca3af;font-size:10px'}, ` /pack of ${packSizeNote}`));
          } else {
            unitTd.appendChild(h('span', {style:'color:#9ca3af'}, '—'));
          }
          tr.appendChild(unitTd);

          const totalTd = h('td', {class:'num'});
          if (lineTotal !== null) {
            totalTd.appendChild(h('strong', {}, _formatPrice(lineTotal)));
          } else if (isOos) {
            totalTd.appendChild(h('span', {style:'color:#b91c1c;font-size:11px'}, 'Not available'));
          } else {
            totalTd.appendChild(h('span', {style:'color:#9ca3af'}, '—'));
          }
          tr.appendChild(totalTd);
        }

        tbody.appendChild(tr);
      }
      tbl.appendChild(tbody);
      sec.appendChild(tbl);
      panel.appendChild(sec);
    }

    tableSection('Poles', bom.pole_packs, true);
    tableSection('Joiners', bom.joiners, true);
    tableSection('Clips', bom.clips, true);
    if (bom.pegs) tableSection('Pegs', [bom.pegs], true);
    if (bom.netting) {
      tableSection('Netting', [_nettingLineItem(bom.netting, priceMap)]);
    }
    if (bom.netting_secondary) {
      tableSection('Netting (side wrap)', [_nettingLineItem(bom.netting_secondary, priceMap)]);
    }

    if (hasPrices && grandTotal > 0) {
      const hasOos = stockMap && [...stockMap.values()].some(v => v === false);
      const totalSec = h('div', { class: 'gncc-parts-section', style: 'margin-top:4px' });
      const totalRow = h('div', { style: 'display:flex;justify-content:space-between;align-items:center;padding:10px 9px;border-top:2px solid #e5e7eb;margin-top:2px' });
      totalRow.appendChild(h('span', { style: 'font-size:13px;font-weight:600;color:#111827' },
        hasOos ? 'Total (in-stock items only)' : 'Total'));
      totalRow.appendChild(h('span', { style: 'font-size:16px;font-weight:700;color:#166534' }, _formatPrice(grandTotal)));
      const note = h('p', { style: 'font-size:11px;color:#9ca3af;margin:4px 9px 0' }, 'Prices at current listed prices. Final price may vary.');
      totalSec.appendChild(totalRow);
      totalSec.appendChild(note);
      panel.appendChild(totalSec);
    }
  }

  function renderCartSection(section, bom, stockMap) {
    section.innerHTML='';
    const skuMap=CFG.skuVariantMap||{};
    if(!Object.keys(skuMap).length)return;
    const{items,unmapped}=resolveCartItems(bom);

    if(unmapped.length){
      const warn=h('div',{class:'gncc-unmapped',style:'display:block'});
      warn.innerHTML=`<strong>Some items couldn't be matched to products:</strong><ul style="margin:6px 0 0;padding-left:18px">${unmapped.map(u=>`<li>${esc(u.sku)} (qty ${u.qty})</li>`).join('')}</ul>`;
      section.appendChild(warn);
    }
    if(!items.length)return;

    const oosItems   = [];
    const inStockItems = [];
    for (const item of items) {
      const entry = _variantCache.get(item.id);
      const available = entry?.available ?? null;
      if (available === false) {
        const sku = Object.entries(skuMap).find(([, v]) => _vid(v) === item.id)?.[0] || `Variant #${item.id}`;
        oosItems.push({ ...item, sku });
      } else {
        inStockItems.push(item);
      }
    }

    const hasOos = oosItems.length > 0;

    if (hasOos) {
      const oosWarn = h('div', { style: 'background:#fff7f7;border:1px solid #fecaca;border-radius:8px;padding:10px 14px;margin-top:10px' });
      oosWarn.innerHTML = `<strong style="color:#b91c1c;font-size:13px">⚠ ${oosItems.length} item${oosItems.length>1?'s':''} out of stock</strong>`
        + `<ul style="margin:6px 0 0;padding-left:18px;font-size:12px;color:#7f1d1d">`
        + oosItems.map(i=>`<li>${esc(i.sku)} (qty ${i.quantity})</li>`).join('')
        + `</ul>`;
      if (inStockItems.length > 0) {
        oosWarn.innerHTML += `<p style="margin:8px 0 0;font-size:12px;color:#b91c1c">The remaining ${inStockItems.length} in-stock item${inStockItems.length>1?'s':''} can still be added to your cart.</p>`;
      } else {
        oosWarn.innerHTML += `<p style="margin:8px 0 0;font-size:12px;color:#b91c1c">No items are currently available to add.</p>`;
      }
      section.appendChild(oosWarn);
    }

    if (!inStockItems.length) return;

    const btnLabel = hasOos
      ? `🛒 Add ${inStockItems.length} in-stock item${inStockItems.length>1?'s':''} to cart`
      : '🛒 Add all items to cart';

    const cartBtn     = h('button',{class:'gncc-btn gncc-btn-cart',type:'button'}, btnLabel);
    const cartSuccess = h('div',{class:'gncc-cart-success'}, hasOos ? '✓ In-stock items added! ' : '✓ Items added! ');
    const cartLink    = h('a',{href:CFG.cartUrl||'/cart',style:'color:#166534;font-weight:500'},'View cart →');
    cartSuccess.appendChild(cartLink);
    const cartError = h('div',{class:'gncc-cart-error'});

    cartBtn.addEventListener('click', async () => {
      cartBtn.disabled=true; cartBtn.textContent='Adding…';
      cartSuccess.style.display='none'; cartError.style.display='none';
      try {
        const freshChecks = await Promise.all(
          inStockItems.map(item => _fetchVariant(item.id, true).then(e => ({ item, available: e?.available ?? true })))
        );
        const nowOos   = freshChecks.filter(c => c.available === false).map(c => c.item);
        const toAdd    = freshChecks.filter(c => c.available !== false).map(c => c.item);

        if (nowOos.length > 0) {
          const skuLabels = nowOos.map(i => Object.entries(skuMap).find(([,v])=>_vid(v)===i.id)?.[0] || `Variant #${i.id}`);
          cartError.innerHTML = `<strong>Just went out of stock:</strong><ul style="margin:4px 0 0;padding-left:16px">${skuLabels.map(s=>`<li>${esc(s)}</li>`).join('')}</ul>`
            + (toAdd.length ? `<p style="margin:6px 0 0">Adding the remaining ${toAdd.length} available item${toAdd.length>1?'s':''} to your cart.</p>` : '');
          cartError.style.display='';
        }

        if (toAdd.length > 0) {
          await addToCart(toAdd);
          cartSuccess.style.display='';
          cartBtn.textContent = nowOos.length ? `✓ ${toAdd.length} item${toAdd.length>1?'s':''} added` : '✓ Added';
          await _refreshCartUI();
        } else {
          cartBtn.disabled=false;
          cartBtn.innerHTML=btnLabel;
        }
      } catch(err) {
        cartError.textContent=`Error: ${err.message}`;
        cartError.style.display='';
        cartBtn.disabled=false;
        cartBtn.innerHTML=btnLabel;
      }
    });

    section.appendChild(cartBtn);
    section.appendChild(cartSuccess);
    section.appendChild(cartError);
  }

  function singleRollNettingNote(bom) {
    if (!isSingleRollNetting(bom.netting, bom.netting_secondary)) return null;
    const displayName = (NETTING_CATALOGUE[bom.netting.netting_type] || {}).display_name || bom.netting.netting_type;
    return `Your ${displayName} arrives as a single continuous 2m-wide roll rather than two separate pieces. Cut it into a ${bom.netting.chosen_length_m}m section for the roof and a ${bom.netting_secondary.chosen_length_m}m section for the side wrap (see the Netting rows in the parts list for exact lengths).`;
  }

  function buildAssemblySteps(bom) {
    const s    = bom.summary || {};
    const dims = bom.dimensions_mm || {};
    const cageType  = bom.cage_type;
    const H         = s.achievable_height_mm || dims.height || 0;
    const W         = dims.width  || 0;
    const L         = dims.length || 0;
    const poleMm    = s.upright_pole_length_mm || H;
    const lenPieces = s.length_bar_pieces_mm || [];
    const widPieces = s.width_bar_pieces_mm  || [];
    const hasNetting = !!bom.netting;
    const hasPegs    = !!bom.pegs;
    const hasDoor    = !!s.door;
    const joinerSystem = bom.joiner_system;
    const isBuildABall = joinerSystem === 'build_a_ball';

    function mm(v) { return v >= 1000 ? `${+(v/1000).toFixed(3).replace(/\.?0+$/, '')}m` : `${Math.round(v)}mm`; }
    function pieces(arr, total) {
      return arr.length > 1
        ? arr.map(p => mm(p)).join(' + ')
        : mm(arr[0] || total);
    }

    if (cageType === 'premium_walk_in') {
      const cornerCount = s.corner_joiners || 4;
      const teeCount    = s.tee_joiners    || 0;
      const totalUp     = s.total_uprights || 4;
      const joinerDesc  = teeCount > 0
        ? `the ${cornerCount} corner joiners and ${teeCount} tee joiners`
        : `the ${cornerCount} corner joiners`;
      const steps = [
        'Ensure the area is flat and level. Mark out the 4 corners of the cage, ideally with string-lines. Taking this extra time at this point will save time with the cage erection.',
        `Push ${joinerDesc} onto ${totalUp} × uprights (2.2m poles) as per the diagram — lock the downward grub screw with the allen key provided.`,
        'Position and push the 2.2m uprights into the ground 300mm, ensuring that the poles are upright.',
        'Slot the crossbars in section by section as per the diagram — lock all remaining grub screws with the allen key provided to secure the frame. Insert an end bung into any open tube ends.',
      ];
      if (s.door) {
        steps.push(
          'Build the door: Slide the 2 hinge eyes onto one of the 1854mm tubes and the hinge eye onto the other 1854mm tube, securing each with a cable tie underneath. Remove the joiner from the upright pole to the right of where you want the door. Slide on the hinge pin and secure underneath with the allen key. Join the 2 × 750mm and 2 × 1854mm tubes with the door corner joiners to create the door frame. Slide two hinge pins onto the 2200mm upright tube and tighten with the allen key to stop them moving. Push the door support upright into the top of the 2200mm tube.',
          'Fit the door: The door can be positioned anywhere on the cage, but the right-hand side (when stood outside) must be next to an upright to enable the door catch to be fitted. Take the 2200mm pole with the door support upright (with the door frame attached) and push it into the ground, then connect onto the crossbar. The door can now be hung on this upright.'
        );
        if (s.door.count > 1) {
          steps.push(`This cage includes ${s.door.count} door kits — repeat the build and fit steps above at each entrance you require, following the same right-hand upright rule.`);
        }
      }
      if (hasNetting) {
        const rollNote = singleRollNettingNote(bom);
        if (rollNote) steps.push(rollNote);
        steps.push(
          '(If ordered with cover) Start at the upright where you require the entrance. Take the side netting to any upright and secure with cable ties (4 per upright and one every 500mm along the top). Walk the net around the full frame keeping it taut. Use the net clamps provided (one per panel between uprights) to secure.',
          'Pull the roof netting out to its full width, lay it over the top of the cage, and secure with cable ties.',
          hasPegs ? 'Bury the edges of the netting in the ground and secure with steel pegs every 500mm.' : 'Bury the edges of the netting in the ground to secure.'
        );
        if (s.door) {
          steps.push(
            hasPegs
              ? 'Fitting netting at the door (Option 1 — netting over door): Starting at the leg from which the door opens, walk around the perimeter keeping the netting taut, securing with cable ties to the frame and pegs into the ground. At the door, open it fully and temporarily attach the netting to cover the door — before fully fixing, test the door opens and closes freely. We generally over-cut the netting so this should not be an issue.'
              : 'Fitting netting at the door (Option 1 — netting over door): Starting at the leg from which the door opens, walk around the perimeter keeping the netting taut, securing with cable ties to the frame and burying the edge into the ground. At the door, open it fully and temporarily attach the netting to cover the door — before fully fixing, test the door opens and closes freely. We generally over-cut the netting so this should not be an issue.',
            'Fitting netting at the door (Option 2 — cut to door shape): Attach netting around the full perimeter as above, then secure the end back to the start. Once attached to the door frame and components, cut out the door shape with scissors and re-attach to the door frame with cable ties.'
          );
        }
        steps.push('(Please Note: if due to heavy forecast of snow please remove roof netting beforehand).');
      }
      return steps;
    }

    if (cageType === 'low_fruit_veg') {
      const wDesc = widPieces.length > 1
        ? `Join the ${pieces(widPieces, W)} tubes using the extension connectors (push-fit sleeve) to form the width bar sections, then push the ends into the joiners on each upright as shown in the diagram.`
        : `Use the ${mm(widPieces[0] || W)} tubes as the width bars, pushing the ends into the joiners on each upright.`;
      const lDesc = lenPieces.length > 1
        ? `Use the ${pieces(lenPieces, L)} tubes as the length bars, joining pairs with extension connectors (push-fit sleeve). These meet at the tee joiner on each internal upright — push both ends into the joiner arms to lock the ${mm(L)} run together.`
        : `Use the ${mm(lenPieces[0] || L)} tubes as the length bars.`;
      const joinerStep = isBuildABall
        ? `Attach a Build-A-Ball joiner to the top of each 16mm upright tube as shown in the cage diagram — one per upright at every position.`
        : `Attach the joiners to the 16mm upright tubes as shown in the cage diagram — corners get corner joiners, edge positions get tee joiners, and interior positions get cross joiners.`;
      return [
        joinerStep,
        wDesc,
        lDesc,
        `Push the 16mm uprights into the ground to achieve an erected height of ${mm(H)}. Use a rubber mallet if needed. Refer to the diagram for spacing.`,
        hasNetting
          ? (hasPegs
              ? `Lay the cover over the assembled frame and secure with the 16mm clips on each upright, spacing the 13mm clips equally along the horizontal bars. Bury the edges and secure with ${bom.pegs.sku} every 500mm.`
              : `Lay the cover over the assembled frame and secure with the 16mm clips on each upright, spacing the 13mm clips equally along the horizontal bars. Bury the edges in the ground to secure.`)
          : `If adding netting, lay it over the frame once assembled and secure with clips on each upright and horizontal bar.`,
      ];
    }

    if (cageType === 'low_19mm') {
      const nUprights = (s.corner_uprights || 4) + (s.internal_uprights || 0);
      const wDesc = widPieces.length > 1
        ? `Use the ${pieces(widPieces, W)} tubes as the width bars. These meet at the corner or tee joiner on each upright — push both ends into the joiner arms to lock the ${mm(W)} run together.`
        : `Use the ${mm(widPieces[0] || W)} tubes as the width bars.`;
      const lDesc = lenPieces.length > 1
        ? `Use the ${pieces(lenPieces, L)} tubes as the length bars. These meet at the tee joiner on each internal upright — push both ends into the joiner arms to lock the ${mm(L)} run together.`
        : `Use the ${mm(lenPieces[0] || L)} tubes as the length bars.`;
      return [
        `Use ${nUprights} of the ${mm(poleMm)} tubes as the uprights. Attach the corner and tee joiners as shown in the cage diagram.`,
        wDesc,
        lDesc,
        `Push the uprights into the ground to the correct erected height of ${mm(H)}. Refer to the height table on the diagram.`,
        hasNetting
          ? (hasPegs
              ? `Lay the cover over the assembled frame and secure using the 19mm pipe clips, spacing them equally over the horizontal bars and uprights. Bury the edges and secure with pegs.`
              : `Lay the cover over the assembled frame and secure using the 19mm pipe clips, spacing them equally over the horizontal bars and uprights. Bury the edges in the ground to secure.`)
          : `If adding netting, lay it over the frame once assembled and secure with 19mm pipe clips.`,
      ];
    }

    const lDesc = lenPieces.length > 1
      ? `Use the ${pieces(lenPieces, L)} tubes as the length bars. These meet at the tee or cross joiner on each internal upright — push both ends into the joiner arms to lock the ${mm(L)} run.`
      : `Use the ${mm(lenPieces[0] || L)} tubes as the length bars.`;
    const wDesc = widPieces.length > 1
      ? `Use the ${pieces(widPieces, W)} tubes as the width bars. These meet at the corner or tee joiner on each upright — push both ends into the joiner arms to lock the ${mm(W)} run together.`
      : `Use the ${mm(widPieces[0] || W)} tubes as the width bars.`;

    const steps = ['Ensure the area is flat and level. Mark out the 4 corners with string-lines.'];

    if (hasDoor) {
      steps.push('Build the door: Slide the 3 hinges onto one of the 1854mm tubes. Join the 2 × 750mm and 2 × 1854mm tubes with the door corner joiners to create the frame. Slide the open side of the hinges onto the 2200mm door upright tube. Tap in the self-tapping screws on the hinge side to stop the hinges from moving. Push the Y connector into the top of the 2200mm tube.');
    }

    steps.push(
      'Mallet the pointed anchors into the ground at each upright position, leaving approximately 12mm still visible above ground.',
      `Push the corner and tee joiners onto the ${mm(poleMm)} upright poles as shown in the diagram. Slot the uprights into the anchors and ensure they are vertical and level.`,
      lDesc,
      wDesc,
      `Push all uprights into the ground to achieve an erected height of ${mm(H)}.`
    );

    if (s.corner_braces > 0) {
      steps.push('Fit the corner brace kits at each corner of the frame to improve rigidity. A mallet is usually required to fully seat the joiners.');
    }

    if (hasDoor) {
      steps.push('Fit the door: The door can be positioned anywhere on the cage, but the right-hand side (when stood outside) must be next to an upright to enable the door catch to be fitted. Push the remaining ground anchor into the ground approximately 800mm from that upright. Take the 2200mm pole with the Y connector (with the door frame attached) and push it up onto the crossbar, slotting it into the anchor at the same time. Fit the door catch onto the two poles.');
      if (s.door.count > 1) {
        steps.push(`This cage includes ${s.door.count} door kits — repeat the build and fit steps above at each entrance you require, following the same right-hand upright rule.`);
      }
    }

    if (hasNetting) {
      const rollNote = singleRollNettingNote(bom);
      if (rollNote) steps.push(rollNote);
      steps.push(
        'Attach the side netting starting at one corner, working around the outside. Secure with cable ties — 4 per upright and one every 500mm along the top bar.',
        'Lay the roof netting over the top of the cage and secure with net clips linking through both the roof and side nettings.'
      );
      if (hasDoor) {
        steps.push(
          hasPegs
            ? 'Fitting netting at the door (Option 1 — netting over door): Starting at the leg from which the door opens, walk around the perimeter keeping the netting taut, securing with cable ties to the frame and pegs into the ground. At the door, open it fully and temporarily attach the netting to cover the door — before fully fixing, test the door opens and closes freely. We generally over-cut the netting so this should not be an issue.'
            : 'Fitting netting at the door (Option 1 — netting over door): Starting at the leg from which the door opens, walk around the perimeter keeping the netting taut, securing with cable ties to the frame and burying the edge into the ground. At the door, open it fully and temporarily attach the netting to cover the door — before fully fixing, test the door opens and closes freely. We generally over-cut the netting so this should not be an issue.',
          'Fitting netting at the door (Option 2 — cut to door shape): Attach netting around the full perimeter as above, then secure the end back to the start. Once attached to the door frame and components, cut out the door shape with scissors and re-attach to the door frame with cable ties.'
        );
      }
    }

    return steps;
  }

  function renderAssemblySection(panel, bom) {
    const steps = buildAssemblySteps(bom);
    if (!steps.length) return;

    const sec = h('div', { style: 'margin-top:20px;padding-top:16px;border-top:1px solid #e5e7eb' });
    sec.appendChild(h('h3', { style: 'margin:0 0 12px;font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;color:#6b7280' }, 'Assembly guide'));

    const ol = h('ol', { style: 'margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:10px' });

    steps.forEach((step, i) => {
      const li = h('div', { style: 'display:flex;gap:10px;align-items:flex-start' });
      const num = h('span', { style: 'flex-shrink:0;width:22px;height:22px;border-radius:50%;background:#1a4b27;color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;margin-top:1px' }, String(i + 1));
      const txt = h('p', { style: 'margin:0;font-size:13px;color:#374151;line-height:1.55' }, step);
      li.appendChild(num);
      li.appendChild(txt);
      ol.appendChild(li);
    });

    sec.appendChild(ol);

    const note = h('p', { style: 'margin:12px 0 0;font-size:11px;color:#9ca3af;font-style:italic' },
      'A mallet is usually required to seat the joiners. Ensure all joiners are fully submerged before use.');
    sec.appendChild(note);
    panel.appendChild(sec);
  }

  function _wrapCanvasText(ctx,text,maxWidth){
    const words=text.split(' ');
    const lines=[];let line='';
    for(const word of words){
      const test=line?line+' '+word:word;
      if(ctx.measureText(test).width>maxWidth&&line){lines.push(line);line=word;}
      else line=test;
    }
    if(line)lines.push(line);
    return lines;
  }

  function downloadDiagramPng(bom,diagWrap,isoWrap){
    const scale=2;
    const groups=[
      {label:'Diagram — top plan & elevation',svgs:[...diagWrap.querySelectorAll('svg')]},
      {label:'3D view',svgs:[...isoWrap.querySelectorAll('svg')]},
    ].filter(g=>g.svgs.length);

    const GROUP_TITLE_H=26;
    const svgData=[];let totalH=0;
    groups.forEach(g=>{
      totalH+=GROUP_TITLE_H;
      g.svgs.forEach((svg,i)=>{
        const vb=svg.viewBox?.baseVal;
        const w=(vb?.width>0?vb.width:svg.getBoundingClientRect().width)||880;
        const hh=(vb?.height>0?vb.height:svg.getBoundingClientRect().height)||400;
        svgData.push({svg,w,hh,groupTitle:i===0?g.label:null});
        totalH+=hh;
      });
    });
    const maxW=Math.max(880,...svgData.map(d=>d.w));

    const steps=buildAssemblySteps(bom);
    const PAD=20,LINE_H=18,TITLE_H=34,NUM_D=20,NUM_GAP=10,FONT='13px sans-serif',TITLE_FONT='bold 15px sans-serif';
    const measureCtx=document.createElement('canvas').getContext('2d');
    measureCtx.font=FONT;
    const textMaxWidth=maxW-PAD*2-NUM_D-NUM_GAP;
    const wrappedSteps=steps.map(step=>_wrapCanvasText(measureCtx,step,textMaxWidth));
    const stepsBlockH=steps.length?(TITLE_H+wrappedSteps.reduce((sum,lines)=>sum+lines.length*LINE_H+10,0)+PAD):0;

    if(!svgData.length&&!steps.length)return;

    const isIOS=/iP(hone|ad|od)/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    const iosWin=isIOS?window.open('','_blank'):null;

    const cvs=document.createElement('canvas');
    cvs.width=maxW*scale;cvs.height=(totalH+stepsBlockH)*scale;
    const ctx=cvs.getContext('2d');ctx.scale(scale,scale);
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,maxW,totalH+stepsBlockH);

    const dims=bom.dimensions_mm;
    const fname=`cage_${bom.cage_type}_${dims.width}x${dims.length}_full_package.png`;

    function drawGroupTitle(text,y){
      ctx.fillStyle='#111827';ctx.font=TITLE_FONT;ctx.textAlign='left';
      ctx.fillText(text,PAD,y+18);
    }

    function drawStepsBlock(startY){
      if(!steps.length)return;
      let y=startY+PAD;
      ctx.fillStyle='#111827';ctx.font=TITLE_FONT;ctx.textAlign='left';
      ctx.fillText('Assembly guide',PAD,y+16);
      y+=TITLE_H;
      wrappedSteps.forEach((lines,i)=>{
        const cy=y+NUM_D/2;
        ctx.fillStyle='#1a4b27';ctx.beginPath();ctx.arc(PAD+NUM_D/2,cy,NUM_D/2,0,Math.PI*2);ctx.fill();
        ctx.fillStyle='#ffffff';ctx.font='bold 10px sans-serif';ctx.textAlign='center';
        ctx.fillText(String(i+1),PAD+NUM_D/2,cy+3.5);
        ctx.textAlign='left';ctx.font=FONT;ctx.fillStyle='#374151';
        lines.forEach((line,li)=>ctx.fillText(line,PAD+NUM_D+NUM_GAP,y+11+li*LINE_H));
        y+=lines.length*LINE_H+10;
      });
    }

    function finish(){
      cvs.toBlob(blob=>{
        if(!blob){if(iosWin)iosWin.close();return;}
        const url=URL.createObjectURL(blob);
        if(iosWin){
          iosWin.location.href=url;
        } else {
          const a=document.createElement('a');a.download=fname;a.href=url;a.click();
        }
        setTimeout(()=>URL.revokeObjectURL(url),60000);
      },'image/png');
    }

    if(!svgData.length){drawStepsBlock(0);finish();return;}

    let yOffset=0,pending=svgData.length;
    svgData.forEach(({svg,w,hh,groupTitle})=>{
      if(groupTitle){drawGroupTitle(groupTitle,yOffset);yOffset+=GROUP_TITLE_H;}
      const blob=new Blob([new XMLSerializer().serializeToString(svg)],{type:'image/svg+xml'});
      const url=URL.createObjectURL(blob);const img=new Image();const capturedY=yOffset;
      img.onload=()=>{ctx.drawImage(img,0,capturedY,w,hh);URL.revokeObjectURL(url);if(--pending===0){drawStepsBlock(totalH);finish();}};
      img.onerror=()=>{URL.revokeObjectURL(url);if(--pending===0){drawStepsBlock(totalH);finish();}};
      img.src=url;yOffset+=hh;
    });
  }

  function onCalculate(){
    const els=formEls.els;
    const cageType=$id('gncc-cage-type').value;
    const widthMm=els.toMm(parseFloat($id('gncc-width').value)||0);
    const lengthMm=els.toMm(parseFloat($id('gncc-length').value)||0);
    const heightMm=els.getHeightMm();
    const nettingType=$id('gncc-netting').value;
    const pegType=$id('gncc-peg').value;
    const joinerSystem=$id('gncc-joiner')?.value||'three_variant';
    const cornerBraces=($id('gncc-corner-braces')?.value??'0')==='1';
    const doorCount=parseInt($id('gncc-door-count')?.value||'0',10);
    const allenKey=$id('gncc-allen-key')?.classList.contains('active')??true;
    const resultsPanel=document.querySelector(`${ROOT_SEL} .gncc-results-panel`);
    const errors=[];
    const MIN_DIM_MM=300,MAX_DIM_MM=20000,MIN_H_MM=400,MAX_H_MM=2200;
    if(!widthMm||isNaN(widthMm))errors.push('Width is required.');
    if(!lengthMm||isNaN(lengthMm))errors.push('Length is required.');
    if(!heightMm||isNaN(heightMm))errors.push('Height is required.');
    if(widthMm<MIN_DIM_MM)errors.push(`Width must be at least ${MIN_DIM_MM/1000}m.`);
    if(lengthMm<MIN_DIM_MM)errors.push(`Length must be at least ${MIN_DIM_MM/1000}m.`);
    if(heightMm<MIN_H_MM)errors.push(`Height must be at least ${MIN_H_MM/1000}m.`);
    if(widthMm>MAX_DIM_MM)errors.push(`Width cannot exceed ${MAX_DIM_MM/1000}m.`);
    if(lengthMm>MAX_DIM_MM)errors.push(`Length cannot exceed ${MAX_DIM_MM/1000}m.`);
    if(heightMm>MAX_H_MM)errors.push(`Height cannot exceed ${MAX_H_MM/1000}m.`);
    if(widthMm<0||lengthMm<0||heightMm<0)errors.push('Dimensions must be positive numbers.');
    if(errors.length){resultsPanel.innerHTML='';const errBox=h('div',{class:'gncc-error'});errBox.innerHTML='<strong>Please correct the following:</strong><ul style="margin:6px 0 0;padding-left:18px">'+errors.map(e=>`<li>${e}</li>`).join('')+'</ul>';resultsPanel.appendChild(errBox);return;}
    try{const bom=calculate(cageType,{heightMm,widthMm,lengthMm,nettingType,pegType,joinerSystem,cornerBraces,doorCount,allenKey});currentBom=bom;renderResults(resultsPanel,bom);}
    catch(err){resultsPanel.innerHTML='';resultsPanel.appendChild(h('div',{class:'gncc-error'},`Calculation failed: ${err.message}`));}
  }

  function onReset(){
    $id('gncc-height').value='0.7';$id('gncc-width').value='1.8';$id('gncc-length').value='3';
    $id('gncc-netting').value='none';
    const doorCountEl=$id('gncc-door-count');
    if(doorCountEl)doorCountEl.value='0';
    const bracesSel=$id('gncc-corner-braces');
    if(bracesSel)bracesSel.value='0';
    const allenBtn=$id('gncc-allen-key');
    if(allenBtn){allenBtn.classList.add('active');allenBtn.setAttribute('aria-pressed','true');allenBtn.textContent='✓ Include allen key (recommended)';}
    currentBom=null;
    const resultsPanel=$('.gncc-results-panel',document.querySelector(ROOT_SEL));
    resultsPanel.innerHTML='';
    resultsPanel.appendChild(buildHowToUseEmptyState());
  }

  function ensureViewportMeta(){
    let meta=document.querySelector('meta[name="viewport"]');
    if(!meta){
      meta=document.createElement('meta');
      meta.setAttribute('name','viewport');
      document.head.appendChild(meta);
    }
    if(!/width\s*=\s*device-width/i.test(meta.getAttribute('content')||'')){
      meta.setAttribute('content','width=device-width, initial-scale=1');
    }
  }

  function init(){
    ensureViewportMeta();
    const root=document.querySelector(ROOT_SEL);
    if(!root)return;

    if (!document.getElementById('gncc-toggle-styles')) {
      const style = document.createElement('style');
      style.id = 'gncc-toggle-styles';
      style.textContent = `
        #gn-cage-calculator .gncc-toggle-btn {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 8px 14px; border-radius: 8px; font-size: 13px; font-weight: 500;
          cursor: pointer; border: 1.5px solid #d1d5db;
          background: #f9fafb; color: #374151;
          transition: background 0.15s, border-color 0.15s, color 0.15s;
          width: 100%; text-align: left;
        }
        #gn-cage-calculator .gncc-toggle-btn:hover {
          background: #f3f4f6; border-color: #9ca3af;
        }
        #gn-cage-calculator .gncc-toggle-btn.active {
          background: #f0fdf4; border-color: #16a34a; color: #15803d; font-weight: 600;
        }
        #gn-cage-calculator .gncc-toggle-btn.active:hover {
          background: #dcfce7;
        }
      `;
      document.head.appendChild(style);
    }

    root.innerHTML='';
    const layout=h('div',{class:'gncc-layout'});
    const resultsPanel=buildResultsPanel();
    formEls=buildForm(root);
    layout.appendChild(formEls.form);
    layout.appendChild(resultsPanel);
    root.appendChild(layout);
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}

})();
